/*
 * Meilisearch collection grid - InstantSearch + instant-meilisearch drive the
 * grid; facets come from the shop metafield aico.filter_settings
 */
(function () {
  'use strict';

  var config = window.MeilisearchCollectionConfig;
  if (!config) {
    console.error('[ms-collection] MeilisearchCollectionConfig not found.');
    return;
  }

  var HOST = config.meilisearchHost;
  var API_KEY = config.meilisearchApiKey;
  var INDEX = config.meilisearchIndex;
  if (!HOST || !API_KEY || !INDEX) {
    console.error('[ms-collection] Missing Meilisearch host / key / index in theme settings.');
    return;
  }

  // Decode `t`-escaped text before ANY of it is captured below (see decodeConfigText).
  decodeConfigText(config);

  // PIM "Kaufbarkeit" flag (tasks 40921/45823/45812) — same reads as
  // meilisearch-core.js; keep the two implementations in sync. Product-level
  // `custom_fields.not_purchasable` indexed as
  // `metafield_custom_fields_not_purchasable`, "true" = blocked, missing =
  // purchasable. No variant counterpart; `variant` is ignored.
  var AVAIL_FLAG_PRODUCT_KEY = config.availabilityFlagProductKey || '';

  function isBlockedFlagValue(v) {
    return v === true || v === 'true' || v === 1 || v === '1';
  }
  function purchaseBlocked(hit, variant) {
    if (AVAIL_FLAG_PRODUCT_KEY && hit && hit[AVAIL_FLAG_PRODUCT_KEY] != null && hit[AVAIL_FLAG_PRODUCT_KEY] !== '') {
      return isBlockedFlagValue(hit[AVAIL_FLAG_PRODUCT_KEY]);
    }
    return false;
  }

  var collectionId = config.collectionId || null;
  var collectionHandle = config.collectionHandle || null;
  var locale = config.currentLocale || 'de';
  var localeTag = (config.localeTag || locale || 'de').replace('_', '-');
  var currency = config.currency || 'CHF';
  var moneyFormat = typeof config.moneyFormat === 'string' && config.moneyFormat.indexOf('{{') !== -1 ? config.moneyFormat : '';
  var showOutOfStock = config.showOutOfStock !== false;
  // Page size in ROWS (Figma: 3 rows, then "Load more"). The product grid is
  // 2 columns on mobile, 3 from 750px and 4 from 1920px — see
  // snippets/collection-toolbar-styles.liquid — so a fixed product count would
  // render a different number of rows at each breakpoint. Resolved once at boot
  // rather than on resize: changing hitsPerPage mid-session would re-slice pages
  // the shopper has already loaded and scrolled past.
  function gridColumnsNow() {
    var w = window.innerWidth;
    if (w >= 1920) return 4;
    if (w >= 750) return 3;
    // Mobile is 2-up unless the section is set to the large mobile card, which
    // drops the grid to a single column (base.css `.product-grid-mobile--large`).
    return document.querySelector('.product-grid-mobile--large') ? 1 : 2;
  }
  var rowsPerPage = parseInt(config.rowsPerPage, 10) || 0;
  var productsPerPage = rowsPerPage
    ? rowsPerPage * gridColumnsNow()
    : config.productsPerPage || 24;
  var productsSuffix = config.productsSuffix || 'Products';
  var productsSuffixOne = config.productsSuffixOne || 'Product';
  function productsCountLabel(nb) { return nb + ' ' + (nb === 1 ? productsSuffixOne : productsSuffix); }
  // Card badge labels (Figma 1653:55510). Fed from the theme's locale files via
  // curaprox-collection-filters.liquid so they follow the storefront language —
  // the grid is built here in JS, so a literal string would stay English on the
  // DE/FR/IT storefronts even though the translations exist.
  var T_BADGE_BESTSELLER = config.badgeBestseller || 'Bestseller';
  var T_BADGE_BACK_IN_STOCK = config.badgeBackInStock || 'Back in stock';
  var T_BADGE_LIMITED_EDITION = config.badgeLimitedEdition || 'Limited edition';
  var T_BADGE_NEW = config.badgeNew || 'New';
  var T_BADGE_SPECIAL_EDITION = config.badgeSpecialEdition || 'Special edition';
  var T_BADGE_BUNDLE = config.badgeBundle || 'Bundle';
  var T_BADGE_ROUTINE = config.badgeRoutine || 'Routine';
  var T_BADGE_NEW_FORMULA = config.badgeNewFormula || 'New formula';
  var T_BADGE_NEW_PACKAGING = config.badgeNewPackaging || 'New packaging';
  var T_BADGE_CHRISTMAS = config.badgeChristmas || 'Christmas';
  var T_BADGE_BLACK_FRIDAY = config.badgeBlackFriday || 'Black Friday';
  var CART_ICON = config.cartIcon || '';
  var STAR_ICON =
    '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" focusable="false"><path d="M12 2l2.95 5.98 6.6.96-4.77 4.65 1.13 6.57L12 17.02l-5.91 3.11 1.13-6.57L2.22 8.94l6.6-.96L12 2z" fill="currentColor"/></svg>';

  // Placeholder rating, matches the current Liquid card
  var RATING_VALUE = config.ratingValue || '4.9';
  var RATING_MAX = config.ratingMax || '5';
  var RATING_COUNT = config.ratingCount || '247';
  var RATING_STARS = parseInt(config.ratingStars, 10) || 5;

  // Sort: radio value maps to a Meilisearch ranking expression "<index>:<field>:<dir>"
  // Both defaults MUST name attributes that are in the index's `sortableAttributes`,
  // otherwise Meilisearch rejects the whole search and the radio silently does
  // nothing while still rendering as selected. Verified against the live index:
  // the date field is `createdAt` — `created_at_timestamp` (the previous default)
  // is not sortable and broke "New from Curaprox" outright.
  var PRICE_FIELD = config.sortPriceField || 'price.defaultPrice';
  var CREATED_FIELD = config.sortCreatedField || 'createdAt';

  // Default order = the collection's order from Shopify admin, which the indexer writes
  // per collection as `position_in_collection_<id>`. No id (/collections/all) → no field.
  //
  // The catch-all needs care: /collections/all is Shopify's virtual page (no admin
  // record, no id), yet the client hand-orders the full catalog. Creating a real
  // collection with the reserved handle `all` does NOT work: Shopify hides such a
  // collection from third-party apps entirely (listing, product.collections, even
  // collectionByHandle — verified against both stores on 2026-08-18), so the search
  // indexer can never see it. Instead the ordering lives in an ordinary collection
  // with the handle below; `boot()` discovers it IN THE INDEX by handle, verifies
  // its position attribute is sortable, and flips these vars before InstantSearch
  // is constructed. Until that probe confirms, the page behaves like the plain
  // virtual catch-all: whole index, no membership filter, index order.
  var ORDER_COLLECTION_HANDLE = 'all-products';
  var IS_ALL_PRODUCTS = config.isAllProducts === true || String(collectionHandle || '').toLowerCase() === 'all';
  var HAS_COLLECTION_ORDER = !!collectionId && !IS_ALL_PRODUCTS;
  // On the catch-all the membership filter only turns on once the probe proves the
  // index knows the ordering collection — otherwise `collections.id = <new id>`
  // matches nothing and the page renders empty (the bug this replaced).
  var FILTER_BY_COLLECTION = HAS_COLLECTION_ORDER;
  var COLLECTION_ORDER_FIELD = '';
  var DEFAULT_SORT = INDEX;
  function computeSortDefaults() {
    COLLECTION_ORDER_FIELD = HAS_COLLECTION_ORDER
      ? 'position_in_collection_' + collectionId
      : '';
    DEFAULT_SORT = COLLECTION_ORDER_FIELD ? INDEX + ':' + COLLECTION_ORDER_FIELD + ':asc' : INDEX;
  }
  computeSortDefaults();

  // The radio the shopper picked, null = default order (all radios unchecked). Tracked
  // separately because "nothing picked" and "Relevance" collapse onto the same ranking.
  var _sortRadio = null;
  // Set once connectSortBy is live: puts the grid back into the default order.
  var _resetSort = null;
  // Accepted ?sort= values; anything else is ignored. Declared out here because the
  // router reads the URL while InstantSearch is still being constructed.
  var SORT_ROUTES = ['relevance', 'price-ascending', 'price-descending', 'created-descending'];

  // Hierarchical category filter (collection hero tabs)
  var categoryMenu = Array.isArray(config.categoryMenu) ? config.categoryMenu : [];
  var CATEGORY_FIELD = config.categoryField || 'collections.id';
  var CATEGORY_MODE = config.categoryMode === 'replace' ? 'replace' : 'accumulate';
  // The facet value used for a node: collection id, unless the field is a handle field
  function catKey(n) {
    if (!n) return '';
    return CATEGORY_FIELD.indexOf('handle') !== -1 ? (n.handle || '') : String(n.id == null ? '' : n.id);
  }
  var _catByKey = {};
  var _catByHandle = {};
  var _catParentKey = {}; // catKey -> parent node's catKey (for label de-duplication)
  (function indexCat(nodes, parent) {
    (nodes || []).forEach(function (n) {
      if (!n) return;
      var k = catKey(n);
      if (k) {
        _catByKey[k] = n;
        if (parent) _catParentKey[k] = catKey(parent);
      }
      if (n.handle) _catByHandle[n.handle] = n;
      indexCat(n.children, n);
    });
  })(categoryMenu, null);

  // Mirrors snippets/collection-short-title.liquid — keep the two in sync. The
  // PIM names sub-categories by prefixing their parent ("Zahnbürste Manual
  // Toothbrushes"), which is pure repetition once the parent is the page itself.
  // Word-boundary prefix only, so a parent "Zahnbürste" never mangles a sibling
  // "Zahnbürsten Zubehör"; a leftover separator is dropped and the label is
  // never emptied.
  var CAT_LABEL_SEPARATORS = ['-', '–', '—', '|', '·', ':'];
  function stripParentPrefix(title, parentTitle) {
    var t = (title || '').trim();
    var p = (parentTitle || '').trim();
    if (!p || t === p || t.indexOf(p + ' ') !== 0) return t;
    var rest = t.slice(p.length + 1).trim();
    if (CAT_LABEL_SEPARATORS.indexOf(rest.charAt(0)) !== -1) rest = rest.slice(1).trim();
    return rest || t;
  }

  function parseCategoryFromUrl() {
    try {
      var raw = new URLSearchParams(window.location.search).get('category');
      if (!raw) return [];
      return raw.split(',').map(function (h) { return _catByHandle[h]; }).filter(Boolean);
    } catch (e) { return []; }
  }

  // Figma 1581:29593 — chip X is an 8px glyph (centred 4→12 in a 16 viewBox) with a
  // fine 1px stroke. Sized to the 16px .cura-chip__x box at 1:1, so neither the glyph
  // nor the stroke is upscaled (the old 14-viewBox @1.5 read ~11px/~1.7px = too heavy).
  var CHIP_X = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 4L4 12" stroke="currentColor" stroke-width="1" stroke-linecap="round"/><path d="M12 12L4 4" stroke="currentColor" stroke-width="1" stroke-linecap="round"/></svg>';

  var filterSettings = { filters: [] };
  try {
    if (typeof config.filterSettings === 'string') {
      filterSettings = JSON.parse(config.filterSettings);
    } else if (config.filterSettings && typeof config.filterSettings === 'object') {
      filterSettings = config.filterSettings;
    }
  } catch (e) {
    console.error('[ms-collection] Error parsing filterSettings:', e);
  }

  // Per-collection scoping: `excludedOnCollections` blacklist + `includedOnCollections`
  // whitelist (the spec's "Filter per Kategorie" matrix is an include-list — see the
  // long-form note in meilisearch-core.js, kept in sync with this copy). Blacklist wins
  // when both are set. This file is loaded standalone on the PLP (the section does not
  // load meilisearch-core.js, only the search page does), so the rule is duplicated
  // here on purpose rather than imported.
  // The filter app's admin stores the scoping lists as collection IDs while older
  // hand-written metafield entries used handles, so a list entry matches on either.
  var scopeKeys = [];
  if (collectionHandle) scopeKeys.push(String(collectionHandle));
  if (collectionId) scopeKeys.push(String(collectionId));
  function scopeListHits(list) {
    for (var i = 0; i < list.length; i++) {
      if (scopeKeys.indexOf(String(list[i])) !== -1) return true;
    }
    return false;
  }
  var sortedFilters = (filterSettings.filters || [])
    .filter(function (f) {
      if (!f || !f.meilisearchField) return false;
      if (!scopeKeys.length) return true;
      if (f.excludedOnCollections && f.excludedOnCollections.length &&
        scopeListHits(f.excludedOnCollections)) return false;
      if (f.includedOnCollections && f.includedOnCollections.length &&
        !scopeListHits(f.includedOnCollections)) return false;
      return true;
    })
    .sort(function (a, b) { return (a.position || 0) - (b.position || 0); });

  // ── Facet field aliases (multi-store) ────────────────────────────────────────
  // CH's PIM renamed the facet fields in 2026-08 and ONE theme serves every store
  // (CLAUDE.md → Multi-store: divergence is resolved at runtime, never by forking).
  // Every theme-side table — filterLabels, valueMap, hiddenValues,
  // DISPLAY_MODE_OVERRIDES, softnessField — is keyed by the CH (canonical) name;
  // this maps a legacy field onto its canonical twin at lookup time so both feeds
  // get the same labels, translations and controls. Unknown fields pass through
  // untouched, so a third spelling just falls back to plain list + metafield label
  // rather than breaking. Keep in sync with meilisearch-core.js.
  //
  // As of 2026-08-14 NO live index still ships these legacy names — the UAE feed
  // (products_test_expansion_curaprox_myshopify_com) was re-synced and its
  // facetDistribution now carries the canonical set, same as CH. The map is kept as
  // a safety net for a store mid-resync; it can be deleted once that is ruled out.
  var FIELD_ALIASES = {
    filter_color: 'filter_farbe',
    filter_whitening: 'group_zahnaufhellung',
    filter_age_group: 'filter_altersgruppe',
    filter_volume: 'group_inhalt',
    group_haertegrad: 'filter_haerte_der_zahnbuerste',
    group_fluoride: 'group_fluoridgehalt',
    group_flavor: 'group_geschmack',
    group_brush_head: 'filter_buerstenkopf'
  };
  function canonicalField(field) {
    return FIELD_ALIASES[field] || field;
  }

  // ── Catalog-wide PLP (/collections/all) allow-list ───────────────────────────
  // The metafield's own scoping is keyed by collection handle, and /collections/all
  // is a virtual collection with no admin record — so the "which filters belong on
  // the all-products page" decision lives in the theme instead
  // (config.allProductsFilters, see curaprox-collection-filters.liquid). It fails
  // CLOSED: only listed fields survive, and they render in the listed order rather
  // than the metafield's global `position`, which is what makes the rail read as a
  // deliberate set instead of "every facet that happens to have data".
  // Applied after canonicalField so a store still on the pre-2026-08 field names
  // matches through FIELD_ALIASES. Empty/absent list = unchanged behaviour.
  var allProductsFilters = config.allProductsFilters || [];
  if (config.isAllProducts && allProductsFilters.length) {
    var rank = {};
    allProductsFilters.forEach(function (field, i) { rank[field] = i; });
    sortedFilters = sortedFilters
      .filter(function (f) { return rank[canonicalField(f.meilisearchField)] !== undefined; })
      .sort(function (a, b) {
        return rank[canonicalField(a.meilisearchField)] - rank[canonicalField(b.meilisearchField)];
      });
  }

  // `meilisearchFields: {fr: "x_fr", …}` = the same facet indexed per language; point
  // the engine at the twin so values come translated from the PIM. Opt-in via
  // config.localizedFields: valueMap/allowedValues are keyed by RAW value, so an
  // unlisted field would lose its curation (or render empty). Ids stay on the base.
  var LOCALIZED_FIELDS = config.localizedFields || [];
  function facetAttrFor(filter) {
    var per = filter && filter.meilisearchFields;
    var attr = per && per[locale];
    if (!attr || attr === filter.meilisearchField) return filter.meilisearchField;
    if (LOCALIZED_FIELDS.indexOf(canonicalField(filter.meilisearchField)) === -1) {
      return filter.meilisearchField;
    }
    FIELD_ALIASES[attr] = filter.meilisearchField;
    return attr;
  }

  // ── Presentation overrides (spreadsheet "Filter · UX-Empfehlung", 2026-07) ────
  // The aico.filter_settings metafield ships nearly every facet as
  // displayMode:"list". These upgrade the facets whose LIVE values actually
  // support a richer control (verified against the index facetDistribution) to
  // the control the UX spec asks for. Scoped to named fields AND only applied
  // while the metafield still holds the default "list", so a mode set explicitly
  // in the metafield later always wins and this quietly stands down (as
  // group_chlorhexidine now does — the metafield sets "radio" itself).
  //
  // Keys track the LIVE index fields as of 2026-08-12: the PIM renamed the facets
  // (filter_color→filter_farbe, filter_whitening→group_zahnaufhellung,
  // filter_volume→group_inhalt, group_fluoride→group_fluoridgehalt,
  // group_flavor→group_geschmack) which is what detached these overrides. group_vegan
  // and group_form no longer exist as facets and are dropped. filter_haerte_der_zahnbuerste
  // stays "list" (its softness meter needs a `levels` map that only the metafield can
  // carry). Keep in sync with the copy in meilisearch-core.js (search page).
  var DISPLAY_MODE_OVERRIDES = {
    filter_farbe: 'swatch', // Multicolor / White / Blue / Brown … → colour dots
    group_zahnaufhellung: 'toggle', // yes / no
    filter_gewachst: 'toggle', // yes / no (UAE only)
    group_inhalt: 'chips', // 10 ml / 200 ml …
    filter_durchmesser_wirksamkeit: 'chips', // 4.0 mm / 5.0 mm / 6.5 mm
    // group_fluoridgehalt deliberately absent: Jan (Asana 1213943973968459,
    // 18.08) wants plain checkboxes — the default "list" mode — not radio.
    group_chlorhexidine: 'radio', // Niedrig / Mittel / Hoch (single choice)
    group_geschmack: 'swatch' // Mint / Watermelon / … → flavour dots + text
  };
  sortedFilters.forEach(function (f) {
    if (!f) return;
    var mode = DISPLAY_MODE_OVERRIDES[canonicalField(f.meilisearchField)];
    if (mode && (!f.displayMode || f.displayMode === 'list')) f.displayMode = mode;
  });

  // ── Price filter ────────────────────────────────────────────────────────────
  // Price is NOT a Meilisearch facet: `price.defaultPrice` is a numeric
  // filterable/sortable attribute, so it needs connectRange rather than
  // connectRefinementList and gets its own rendering path (wirePriceRangeGroup).
  // Everything else about it is an ordinary filter: it exists, is labelled and is
  // ordered by an `aico.filter_settings` entry with `displayMode: "range"`, exactly
  // like every other group. The theme injects nothing — no entry, no price group.
  //
  //   { "meilisearchField": "price.defaultPrice", "displayMode": "range",
  //     "label": "Preis", "position": 1,
  //     "translations": { "de": "Preis", "en": "Price", "fr": "Prix", "it": "Prezzo" },
  //     "buckets": "[{\"max\":10},{\"min\":10,\"max\":25},{\"min\":25}]" }   // buckets optional
  //
  // `buckets` may also come from the theme setting (config.priceFilter.buckets) as a
  // shop-wide default; the entry's own value wins. The three ancillary strings (the
  // "Bis X" prefix and the two slider aria-labels) stay in the theme's locale files —
  // they are UI chrome, not per-filter copy.
  var PRICE_FIELD_FILTER = config.priceFilterField || 'price.defaultPrice';
  var priceCfg = config.priceFilter || {};

  // The filter app writes `type: "price"` + `numeric: true` and leaves displayMode on
  // "list" (its UI has no range option), so any of those signals selects the slider.
  function isRangeFilter(filter) {
    if (!filter) return false;
    return filter.displayMode === 'range' ||
      filter.numeric === true ||
      filter.type === 'price' ||
      filter.meilisearchField === PRICE_FIELD_FILTER;
  }

  // Preset buckets. `min`/`max` are inclusive/exclusive bounds in shop currency;
  // an absent bound means open-ended, which is how "under X" and "X and up" are
  // expressed. Overridable per shop via the section setting.
  var DEFAULT_PRICE_BUCKETS = [
    { max: 10 },
    { min: 10, max: 25 },
    { min: 25, max: 50 },
    { min: 50 }
  ];

  function priceBuckets(filter) {
    var b = filter.buckets || priceCfg.buckets;
    if (typeof b === 'string') {
      try { b = JSON.parse(b); } catch (e) { b = null; }
    }
    return (Array.isArray(b) && b.length) ? b : DEFAULT_PRICE_BUCKETS;
  }

  // Returns HTML: the amounts carry the Dirham sign in AED (moneyHtml), so the
  // text label is escaped here and the caller must not escape again.
  function priceBucketLabelHtml(bucket) {
    var lo = bucket.min != null ? moneyHtml(bucket.min) : null;
    var hi = bucket.max != null ? moneyHtml(bucket.max) : null;
    if (lo && hi) return lo + ' – ' + hi;
    if (hi) return escapeHtml(priceCfg.underLabel || 'Bis') + ' ' + hi;
    return lo + ' +';
  }

  var fieldLabelMap = {};
  sortedFilters.forEach(function (f) {
    fieldLabelMap[f.meilisearchField] = getFilterLabel(f);
  });

  // Small utilities
  function escapeHtml(text) {
    if (text == null) return '';
    var d = document.createElement('div');
    d.textContent = String(text);
    return d.innerHTML;
  }

  // Liquid's `t` filter returns HTML-ESCAPED text, so a translation containing an
  // ampersand reaches this file as "Baby &amp; Kind". Everything here is written
  // into innerHTML through escapeHtml(), which escapes it a second time and renders
  // the entity literally. Decode once on the way in so the single escape at render
  // time is the only one. Uses a textarea: it parses entities without ever running
  // markup, so a config string can't inject anything.
  function decodeEntities(text) {
    if (text == null) return '';
    var s = String(text);
    if (s.indexOf('&') === -1) return s;
    var ta = document.createElement('textarea');
    ta.innerHTML = s;
    return ta.value;
  }

  // Liquid's `t` returns HTML-ESCAPED text ("Jusqu&#39;à"), which escapeHtml() would
  // escape again at render time — decode the whole config once, up front. Keys holding
  // markup (icons, swatch templates) are skipped. The regex is inline because this runs
  // above, before a module-level `var` here would be assigned (hoisting).
  function decodeConfigText(value, key) {
    if (typeof value === 'string') {
      return (key && /(icon|svg|template)$/i.test(key)) ? value : decodeEntities(value);
    }
    if (Array.isArray(value)) {
      return value.map(function (v) { return decodeConfigText(v, key); });
    }
    if (value && typeof value === 'object') {
      Object.keys(value).forEach(function (k) {
        value[k] = decodeConfigText(value[k], k);
      });
    }
    return value;
  }

  // Facet group heading, most specific source first:
  //
  //   1. `translations[locale]` on the aico.filter_settings entry — per-store copy,
  //      always wins so a merchant can override anything below.
  //   2. The theme's own locale files, keyed by meilisearchField (see
  //      snippets/curaprox-collection-filters.liquid → filterLabels). The metafield
  //      carries ONE label for all locales, and this store's are English
  //      ("Whitening", "Age Group", "Color"), so without this the German storefront
  //      showed English headings with nothing the theme could do about it.
  //   3. The metafield's raw `label`, then the field name as a last resort — so an
  //      attribute the theme has never heard of still renders something sensible.
  // Read `config` inside the function, NOT via a module-level `var` initialised here:
  // getFilterLabel runs during top-level setup (the sortedFilters pass above) which
  // executes BEFORE this point in the file, so a hoisted-but-unassigned var would be
  // `undefined` at that moment and the property read would throw, taking the whole PLP
  // down with it.
  function getFilterLabel(filter) {
    var themeLabels = config.filterLabels || {};
    if (filter.translations && filter.translations[locale]) return decodeEntities(filter.translations[locale]);
    var themeLabel = themeLabels[canonicalField(filter.meilisearchField)];
    if (themeLabel) return decodeEntities(themeLabel);
    return decodeEntities(filter.label || filter.meilisearchField);
  }

  function sanitizeId(val) {
    return String(val).replace(/[^a-zA-Z0-9_-]/g, '_');
  }

  var SRCSET_WIDTHS = [200, 360, 540, 720, 900];
  function imageUrl(src, width) {
    if (!src) return '';
    var sep = src.indexOf('?') !== -1 ? '&' : '?';
    return src + sep + 'width=' + width;
  }
  function srcset(src) {
    if (!src) return '';
    return SRCSET_WIDTHS.map(function (w) { return imageUrl(src, w) + ' ' + w + 'w'; }).join(', ');
  }
  // Frontify (media.ffycdn.net) assets ship as full-size originals (~220KB avg,
  // up to ~900KB PNG); its CDN resizes/transcodes via query params. width=1200
  // is the smallest PDP-ladder step (ovi-img-src.liquid / media-gallery.js)
  // covering the largest card rendering (553 CSS px x DPR 2 = 1106 device px
  // on the 2560px 4-col grid, measured 2026-08-27). Non-Frontify
  // URLs pass through untouched. Keep in sync with snippets/ovi-img-url.liquid
  // and the copy in meilisearch-core.js.
  function frontifySizedUrl(src, width) {
    if (!src || src.indexOf('media.ffycdn.net') === -1) return src || '';
    var sep = src.indexOf('?') !== -1 ? '&' : '?';
    return src + sep + 'width=' + width + '&format=webp';
  }

  // Currencies whose minor unit is not 1/100 (subset of assets/money-formatting.js).
  var MONEY_DECIMALS = { BHD: 3, IQD: 3, JOD: 3, KWD: 3, LYD: 3, OMR: 3, TND: 3, JPY: 0, KRW: 0, ISK: 0, CLP: 0, VND: 0, XAF: 0, XOF: 0 };
  // Renders a MAJOR-unit amount through Shopify's money format template, the
  // same placeholder rules as the Liquid `money` filter / assets/money-formatting.js
  // (kept as a plain function here: this file is not an ES module).
  function formatMoneyTemplate(amount, format, cur) {
    var precision = MONEY_DECIMALS[String(cur || '').toUpperCase()];
    if (precision == null) precision = 2;
    return format.replace(/{{\s*(\w+)\s*}}/g, function (_, placeholder) {
      if (placeholder === 'currency') return cur;
      var thousands = ',', decimal = '.', p = precision;
      switch (placeholder) {
        case 'amount_no_decimals': p = 0; break;
        case 'amount_with_comma_separator': thousands = '.'; decimal = ','; break;
        case 'amount_no_decimals_with_comma_separator': thousands = '.'; p = 0; break;
        case 'amount_no_decimals_with_space_separator': thousands = ' '; p = 0; break;
        case 'amount_with_space_separator': thousands = ' '; decimal = ','; break;
        case 'amount_with_period_and_space_separator': thousands = ' '; decimal = '.'; break;
        case 'amount_with_apostrophe_separator': thousands = "'"; decimal = '.'; break;
        default: break;
      }
      var parts = Math.abs(amount).toFixed(p).split('.');
      var whole = parts[0].replace(/\d(?=(\d\d\d)+(?!\d))/g, function (d) { return d + thousands; });
      var out = p <= 0 ? whole : whole + decimal + (parts[1] || '').padEnd(p, '0');
      return amount < 0 ? '-' + out : out;
    });
  }

  function formatMoney(amount, cur) {
    var n = Number(amount);
    if (!isFinite(n)) return '';
    var c = cur || currency;
    // Shop money format first (UAE audit #8): matches the Liquid-rendered prices
    // exactly. The template is specific to the shop currency, so a hit priced in
    // another currency (not the case today) still goes through Intl below.
    if (moneyFormat && c === currency) return formatMoneyTemplate(n, moneyFormat, c);
    try {
      return new Intl.NumberFormat(localeTag, { style: 'currency', currency: c }).format(n);
    } catch (e) {
      return n.toFixed(2) + ' ' + c;
    }
  }

  // UAE Dirham sign (T142564): same markup as snippets/money.liquid, keep them in
  // sync. AED gets the sign (CSS mask; its text "AED" is what screen readers and
  // copy/paste get). Other currencies, or an amount that doesn't parse, stay plain.
  function moneyHtml(amount, cur) {
    var text = formatMoney(amount, cur);
    if ((cur || currency) !== 'AED') return text;
    var num = text.replace(/Dhs\.|AED|\u062F\.\u0625/g, '').trim();
    var minus = '';
    if (num.indexOf('-') !== -1) {
      minus = '-';
      num = num.replace(/-/g, '').trim();
    }
    if (!/^\d(?:.*\d)?$/.test(num)) return text;
    return minus + '<span class="money-aed"><span class="aed-sign">AED</span>&nbsp;' + num + '</span>';
  }

  // Card rendering (pure JS) - reproduces the native product-card markup so the
  // theme CSS styles it and Horizon's custom elements (slideshow, quick-add) upgrade
  // Locale root for every product URL built below. Prefer the Liquid-supplied
  // config.rootUrl: window.Shopify.routes.root was empty when this deferred module
  // captured it, so cards linked to the unprefixed path — which serves the ENGLISH
  // page and made quick-add / add-to-cart modals (they fetch the card href) open in
  // English on /de. Normalised to always end in exactly one '/'.
  var ROOT_PATH = (function () {
    var r = config.rootUrl || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  })();
  var CART_ICON = config.cartIcon || '';
  var RATING_VALUE = config.ratingValue || '4.9';
  var RATING_MAX = config.ratingMax || '5';
  var RATING_COUNT = config.ratingCount || '247';
  var RATING_STARS = parseInt(config.ratingStars, 10) || 5;
  var STAR_ICON =
    '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" focusable="false"><path d="M12 2l2.95 5.98 6.6.96-4.77 4.65 1.13 6.57L12 17.02l-5.91 3.11 1.13-6.57L2.22 8.94l6.6-.96L12 2z" fill="currentColor"/></svg>';

  // ── Variant-split documents ─────────────────────────────────────────────────
  // The filter app splits configured products into one document per option-value
  // group: id "v<firstVariantId>", `productId` = the parent Shopify product,
  // `splitValues` = {optionName: value} the group stands for, `variants[]` =
  // only that group's variants (hit.options still lists EVERY product option
  // value). Unsplit products keep one doc whose id equals productId and whose
  // splitValues is absent/empty. Cards must label and deep-link each group —
  // otherwise every card of a split product renders with an identical title.
  // Keep in sync with the same helpers in meilisearch-core.js (search cards).
  function splitLabel(hit) {
    var sv = hit && hit.splitValues;
    if (!sv || typeof sv !== 'object') return '';
    var parts = [];
    for (var k in sv) {
      if (Object.prototype.hasOwnProperty.call(sv, k) && sv[k] != null && String(sv[k]).trim()) {
        parts.push(String(sv[k]).trim());
      }
    }
    return parts.join(' / ');
  }
  // Online stock: availableForSale is not accurate for online inventory, so a tracked
  // deny-policy variant reads sellableOnlineQuantity; continue-selling and untracked sell at any stock
  function isVariantInStock(v) {
    if (!v) return false;
    if (v.inventoryPolicy === 'CONTINUE' || v.inventoryTracked === false) return true;
    if (typeof v.sellableOnlineQuantity === 'number') return v.sellableOnlineQuantity > 0;
    return !!v.availableForSale;
  }
  function isSplitHit(hit) { return splitLabel(hit) !== ''; }
  // The variant a split card stands for: first sellable in the group, else the first.
  function splitVariant(hit) {
    var vs = Array.isArray(hit.variants) ? hit.variants : [];
    for (var i = 0; i < vs.length; i++) { if (vs[i] && isVariantInStock(vs[i])) return vs[i]; }
    return vs[0] || null;
  }
  // Split option values are canonical raw strings (option values are deliberately
  // NOT translated, see the T&A cleanup of 2026-08-11), so one label serves every
  // locale.
  function getTitle(hit) {
    var t = hit['title_' + locale] || hit.title || 'Product';
    var s = splitLabel(hit);
    return s ? t + ' – ' + s : t;
  }
  function getHandle(hit) { return hit['handle_' + locale] || hit.handle || ''; }
  function getSubtitle(hit) {
    return hit['productType_' + locale] || hit.productType || hit.product_type || '';
  }
  function getImageObj(hit) {
    var imgs = hit.images;
    return (Array.isArray(imgs) && imgs.length) ? imgs[0] : null;
  }
  // Parse the hit's `option_value_images` metafield once (string or object).
  // `option_value_images` is the hand-written key; the filter app's "Extra
  // Included Metafields" writes product metafields as flat
  // `metafield_<namespace>_<key>` doc fields (see shopify-filter-app
  // app-setting.ts extraMetafieldId), so the OVI metafield arrives as
  // `metafield_custom_fields_option_value_images` once configured per store.
  function oviData(hit) {
    var ovi = hit.option_value_images || hit.metafield_custom_fields_option_value_images;
    if (typeof ovi === 'string') {
      try { ovi = JSON.parse(ovi); } catch (e) { return null; }
    }
    return (ovi && typeof ovi === 'object') ? ovi : null;
  }
  // A variant's per-colour [main, hover(second)] image URLs from the OVI metafield
  // — the SAME source the PDP gallery uses. Tries the widest set of candidate keys
  // because Meili variant objects vary in what they expose: variant SKU, SKU prefix,
  // option1/2/3, each title segment, AND the colour value name (`valueName`) the
  // swatch already resolved — the last covers value-keyed OVI ("Blue"/"Purple"/…)
  // when the variant carries no sku/option fields. Each candidate is matched exact,
  // capitalised, and handleized against handleized OVI keys (so "Dark Blue" ≈
  // "dark-blue"). [] when the metafield is absent or nothing matches.
  function oviVariantImages(hit, variant, valueName) {
    var data = oviData(hit);
    if (!data) return [];
    var keys = [];
    if (variant) {
      var sku = variant.sku != null ? String(variant.sku).trim() : '';
      if (sku) {
        keys.push(sku);
        if (sku.indexOf('-') !== -1) keys.push(sku.replace(/-[^-]*$/, ''));
      }
      if (variant.option1 != null) keys.push(String(variant.option1));
      if (variant.option2 != null) keys.push(String(variant.option2));
      if (variant.option3 != null) keys.push(String(variant.option3));
      if (variant.title != null) {
        String(variant.title).split(' / ').forEach(function (seg) { keys.push(seg); });
      }
    }
    if (valueName != null) keys.push(String(valueName));
    if (!keys.length) return [];

    // Index OVI keys by their handleized form once, for the fuzzy pass.
    var byHandle = null;
    function handleIndex() {
      if (byHandle) return byHandle;
      byHandle = {};
      for (var key in data) {
        if (key === '__general') continue;
        byHandle[handleizeValue(key)] = data[key];
      }
      return byHandle;
    }

    function pick(entry) {
      if (entry && Array.isArray(entry.images) && entry.images.length) {
        var main = entry.images[0];
        var hover = entry.images.length > 1 ? entry.images[1] : (entry.hover || '');
        // Downsize raw Frontify originals to card size at the single exit point,
        // so every consumer (swatch data-image / data-hover-image) gets ~48KB
        // WebP instead of the ~220KB-900KB original.
        return [frontifySizedUrl(main, 1200), frontifySizedUrl(hover, 1200)];
      }
      return null;
    }

    for (var i = 0; i < keys.length; i++) {
      var k = String(keys[i]).trim();
      if (!k) continue;
      // Exact, then capitalised, then handleized.
      var hit1 = pick(data[k]) ||
        pick(data[k.charAt(0).toUpperCase() + k.slice(1)]) ||
        pick(handleIndex()[handleizeValue(k)]);
      if (hit1) return hit1;
    }
    return [];
  }
  function getPrice(hit) {
    var p = hit.price;
    if (p && typeof p === 'object') {
      return { amount: p.defaultPrice != null ? p.defaultPrice : p.minPrice, currency: p.currency || currency };
    }
    return { amount: p, currency: currency };
  }
  // --- Facet value mapping ---------------------------------------------------
  // The index stores ONE raw string per attribute, in whatever language and
  // spelling the upstream feed produced: group_chlorhexidine carries "Medium",
  // "Medium (targeted care)" and the German twin "Mittel (gezielte Pflege)" for
  // the same level, as three separate rows. Facet VALUES
  // are not a Shopify resource, so Translate & Adapt cannot reach them, and the
  // `translations` block on aico.filter_settings covers group LABELS only.
  // Both jobs therefore have to land here, at render time.
  //
  //   config.valueMap[field]     -> [{ label, values: [raw, ...] }, ...]
  //       Collapses N raw values into ONE option: its count is their sum, and
  //       picking it refines every member (operator 'or', so it reads as a
  //       single row rather than N synonyms).
  //   config.hiddenValues[field] -> [raw, ...] dropped from the rail entirely.
  //
  // Unmapped values pass through untouched, so a value the feed adds tomorrow
  // still renders — untranslated, but never silently missing.
  // Labels are decoded once here (see decodeEntities): they come from the `t`
  // filter, so "Baby & Kids" arrives as "Baby &amp; Kids" and would otherwise be
  // escaped twice on the way into the DOM. Raw `values` are index strings, never
  // rendered, so they are left exactly as the engine reports them.
  var VALUE_MAP = (function (map) {
    var out = {};
    Object.keys(map || {}).forEach(function (field) {
      out[field] = (map[field] || []).map(function (group) {
        return { label: decodeEntities(group.label), values: group.values || [] };
      });
    });
    return out;
  })(config.valueMap);
  var HIDDEN_VALUES = config.hiddenValues || {};
  //   config.allowedValues[field] -> [raw, ...] the ONLY values that may render —
  //       the inverse of hiddenValues, for facets whose noise grows on its own.
  var ALLOWED_VALUES = config.allowedValues || {};

  // Synthetic option values carry a prefix that cannot occur in a real facet
  // value, so a mapped row can never collide with one from the engine.
  var MAPPED_PREFIX = '@@map:';

  // Delimiter for packing the several raw facet values a merged chip stands for
  // into one data-val. Unit Separator: a control char, so it cannot occur inside
  // a product attribute string. Written as an escape, never as a literal byte.
  var SEP = '\u001F';

  function mappedGroupsFor(field) {
    var groups = VALUE_MAP[canonicalField(field)];
    return Array.isArray(groups) && groups.length ? groups : null;
  }

  function isHiddenValue(field, raw) {
    var list = HIDDEN_VALUES[canonicalField(field)];
    return Array.isArray(list) && list.indexOf(raw) !== -1;
  }

  // An empty allow-list is treated as "no allow-list" rather than "hide everything",
  // so a mis-typed config can't blank a whole group.
  function isAllowedValue(field, raw) {
    var list = ALLOWED_VALUES[canonicalField(field)];
    if (!Array.isArray(list) || !list.length) return true;
    return list.indexOf(raw) !== -1;
  }

  // Raw engine facet values -> display options. Merged options keep the position
  // of their first member, so the engine's ordering still drives the rail.
  function mapFacetItems(field, items) {
    var groups = mappedGroupsFor(field);
    var byKey = {};
    var out = [];
    items.forEach(function (item) {
      if (isHiddenValue(field, item.value)) return;
      if (!isAllowedValue(field, item.value)) return;
      var gi = -1;
      if (groups) {
        for (var i = 0; i < groups.length; i++) {
          if ((groups[i].values || []).indexOf(item.value) !== -1) { gi = i; break; }
        }
      }
      if (gi === -1) { out.push(item); return; }

      var key = MAPPED_PREFIX + field + ':' + gi;
      if (byKey[key]) {
        byKey[key].count += item.count || 0;
        byKey[key].isRefined = byKey[key].isRefined || !!item.isRefined;
        byKey[key].rawValues.push(item.value);
        return;
      }
      byKey[key] = {
        value: key,
        label: groups[gi].label || item.label,
        count: item.count || 0,
        isRefined: !!item.isRefined,
        rawValues: [item.value]
      };
      out.push(byKey[key]);
    });
    return out;
  }

  // Raw facet value -> the label the rail shows for it. The applied-filter chips
  // are built from InstantSearch's own currentRefinements list, which never goes
  // through mapFacetItems(), so without this a chip reads "Medium fluoride" while
  // the group right above it reads "Mittlerer Fluoridgehalt".
  function displayValueLabel(field, raw) {
    var groups = mappedGroupsFor(field);
    if (!groups) return raw;
    for (var i = 0; i < groups.length; i++) {
      if ((groups[i].values || []).indexOf(raw) !== -1) return groups[i].label || raw;
    }
    return raw;
  }

  // Canonical badge whitelist — mirrors the Liquid card / PDP header
  // (snippets/product-details-header.liquid). Maps a normalized tag (lowercased,
  // non-alphanumerics stripped) to the short class-name key used by the shared card
  // CSS (snippets/curaprox-product-card-styles.liquid) and a localized label. Native
  // product.tags are the only badge source in the Meili index (the PIM flag metafield
  // / aico_tags are not indexed), so this reads tags; the badge SET + first-4 cap match.
  var BADGE_WHITELIST = [
    { tag: 'bestseller', key: 'bestseller', label: T_BADGE_BESTSELLER },
    { tag: 'new', key: 'new', label: T_BADGE_NEW },
    { tag: 'backinstock', key: 'backinstock', label: T_BADGE_BACK_IN_STOCK },
    { tag: 'limitededition', key: 'limited', label: T_BADGE_LIMITED_EDITION },
    { tag: 'specialedition', key: 'special', label: T_BADGE_SPECIAL_EDITION },
    { tag: 'bundle', key: 'bundle', label: T_BADGE_BUNDLE },
    { tag: 'routine', key: 'routine', label: T_BADGE_ROUTINE },
    { tag: 'newformula', key: 'newformula', label: T_BADGE_NEW_FORMULA },
    { tag: 'newpackaging', key: 'newpackaging', label: T_BADGE_NEW_PACKAGING },
    { tag: 'christmas', key: 'christmas', label: T_BADGE_CHRISTMAS },
    { tag: 'blackfriday', key: 'blackfriday', label: T_BADGE_BLACK_FRIDAY }
  ];
  // Returns the matched badge descriptors in the tags' authored order, deduped.
  function getBadges(hit) {
    var raw = hit.tags;
    if (typeof raw === 'string') raw = raw.split(',');
    if (!Array.isArray(raw)) raw = [];
    var seen = {};
    var out = [];
    raw.forEach(function (t) {
      var norm = String(t).toLowerCase().replace(/[^a-z0-9]/g, '');
      for (var i = 0; i < BADGE_WHITELIST.length; i++) {
        if (BADGE_WHITELIST[i].tag === norm && !seen[BADGE_WHITELIST[i].key]) {
          seen[BADGE_WHITELIST[i].key] = true;
          out.push(BADGE_WHITELIST[i]);
          break;
        }
      }
    });
    return out;
  }
  function isAvailable(hit) {
    if (Array.isArray(hit.variants) && hit.variants.length) {
      return hit.variants.some(function (v) { return v && isVariantInStock(v); });
    }
    if (hit.totalInventory != null) return Number(hit.totalInventory) > 0;
    return true;
  }

  // Static star rating from the indexed Yotpo review metafields (Figma 1653:66534):
  // fractional stars + "avg/ 5" + "(count)", hardcoded 0 state when absent. Mirrors
  // snippets/curaprox-card-rating.liquid incl. its curaprox-rating-resolve healing:
  // when metafield_yotpo_preloaded_star_distribution is indexed and its total exceeds
  // reviews_count (stale write-back), count + weighted average are re-derived from it.
  // Keep byte-identical with the search copy in meilisearch-core.js.
  function renderRatingHtml(hit) {
    var avgRaw = hit && hit.metafield_yotpo_reviews_average;
    var cntRaw = hit && hit.metafield_yotpo_reviews_count;
    var avgNum = parseFloat(avgRaw);
    if (isNaN(avgNum) || avgNum < 0) avgNum = 0;
    if (avgNum > 5) avgNum = 5;
    var cntNum = parseInt(cntRaw, 10);
    if (isNaN(cntNum) || cntNum < 0) cntNum = 0;
    var distRaw = hit && hit.metafield_yotpo_preloaded_star_distribution;
    if (distRaw) {
      try {
        var dist = typeof distRaw === 'string' ? JSON.parse(distRaw) : distRaw;
        var sum = 0;
        var weight = 0;
        for (var s = 1; s <= 5; s++) {
          var n = parseInt(dist[String(s)], 10) || 0;
          if (n > 0) {
            sum += n;
            weight += s * n;
          }
        }
        if (sum > cntNum) {
          cntNum = sum;
          avgNum = Math.round((weight / sum) * 10) / 10;
        }
      } catch (err) {
        /* malformed distribution snapshot → keep the raw metafields */
      }
    }
    var fill = (avgNum * 20).toFixed(2);
    var avgDisp = avgNum % 1 === 0 ? String(avgNum) : avgNum.toFixed(1);
    var cntDisp = String(cntNum);
    var star = '<svg class="cpc-info__stars-icon" viewBox="0 0 32 32" focusable="false" aria-hidden="true"><path d="M31.547 12a.848.848 0 00-.677-.577l-9.427-1.376-4.224-8.532a.847.847 0 00-1.516 0l-4.218 8.534-9.427 1.355a.847.847 0 00-.467 1.467l6.823 6.664-1.612 9.375a.847.847 0 001.23.893l8.428-4.434 8.432 4.432a.847.847 0 001.229-.894l-1.615-9.373 6.822-6.665a.845.845 0 00.214-.869z"/></svg>';
    var five = star + star + star + star + star;
    return (
      '<div class="cpc-info__rating">' +
      '<span class="cpc-info__stars" style="--stars-fill: ' + fill + '%;" aria-hidden="true">' +
      '<span class="cpc-info__stars-row cpc-info__stars-row--empty">' + five + '</span>' +
      '<span class="cpc-info__stars-clip"><span class="cpc-info__stars-row cpc-info__stars-row--full">' + five + '</span></span>' +
      '</span>' +
      '<span class="cpc-info__rating-score">' + escapeHtml(avgDisp) + '/ 5</span>' +
      '<span class="cpc-info__rating-count">(' + escapeHtml(cntDisp) + ')</span>' +
      '</div>'
    );
  }
  function renderBadgesHtml(hit) {
    var badges = getBadges(hit);
    if (!badges.length) return '';
    // First 4 only — matches the CSS soft cap on the Liquid card.
    var html = '';
    for (var i = 0; i < badges.length && i < 4; i++) {
      html += '<span class="curaprox-card-badge curaprox-card-badge--' + badges[i].key + '">' + escapeHtml(badges[i].label) + '</span>';
    }
    return '<div class="curaprox-card-badges">' + html + '</div>';
  }

  // Settings that drive the gallery / quick-add markup (from the section)
  var CARD_CAROUSEL = config.cardCarousel === true;
  var SECOND_IMAGE_ON_HOVER = config.secondImageOnHover === true;
  var QUICK_ADD_ENABLED = config.quickAddEnabled !== false;
  var ADD_TO_CART_ICON = config.addToCartIcon || '';
  var ADDED_ICON = config.addedIcon || '';
  var CART_ADD_URL = config.cartAddUrl || (ROOT_PATH + 'cart/add');
  var MEDIA_WIDTHS = [200, 360, 540, 720, 900, 1200, 1600];
  function mediaSrcset(src) {
    if (!src) return '';
    return MEDIA_WIDTHS.map(function (w) { return imageUrl(src, w) + ' ' + w + 'w'; }).join(', ');
  }
  function imgSrcOf(im) { return typeof im === 'string' ? im : (im && (im.src || im.url) || ''); }

  // Sale / sold-out badge, mirrors blocks/_product-card-gallery.liquid
  function buildProductBadges(hit) {
    var available = isAvailable(hit);
    var v0 = (Array.isArray(hit.variants) && hit.variants[0]) || null;
    var onSale = hit.isSale === true || (v0 && v0.compareAtPrice != null && Number(v0.compareAtPrice) > Number(v0.price));
    if (available && !onSale) return '';
    var label = !available ? (config.soldOutText || 'Sold out') : (config.saleText || 'Sale');
    return (
      '<div class="product-badges product-badges--' + escapeHtml(config.badgePosition || 'bottom-left') + '">' +
      '<div class="product-badges__badge product-badges__badge--rectangle">' + escapeHtml(label) + '</div>' +
      '</div>'
    );
  }

  // Prev/next arrows, mirrors snippets/slideshow-arrows + slideshow-arrow
  function buildArrows() {
    var arrow = config.arrowIcon || '';
    return (
      '<slideshow-arrows position="center">' +
      '<button class="slideshow-control slideshow-control--previous slideshow-control--style-arrow button button-unstyled button-unstyled--transparent flip-x" aria-label="' + escapeHtml(config.prevLabel || 'Previous') + '" on:click="/previous" ref="previous"><span class="svg-wrapper icon-arrow">' + arrow + '</span></button>' +
      '<button class="slideshow-control slideshow-control--next slideshow-control--style-arrow button button-unstyled button-unstyled--transparent" aria-label="' + escapeHtml(config.nextLabel || 'Next') + '" on:click="/next" ref="next"><span class="svg-wrapper icon-arrow">' + arrow + '</span></button>' +
      '</slideshow-arrows>'
    );
  }

  // Card gallery - real <slideshow-component> carousel, or title placeholder when no media
  function buildGallery(hit, title, url) {
    var imgs = (Array.isArray(hit.images) ? hit.images : []).filter(function (im) { return imgSrcOf(im); });
    var quickAdd = buildQuickAdd(hit);
    var badges = buildProductBadges(hit);

    if (!imgs.length) {
      return (
        '<div ref="cardGallery" class="card-gallery spacing-style border-style" data-image-ratio="portrait" style="--gallery-aspect-ratio: 4 / 5;">' +
        '<product-title class="product-card-gallery__title-placeholder">' +
        '<a class="contents" href="' + escapeHtml(url) + '" aria-hidden="true"><span class="title-text">' + escapeHtml(title) + '</span></a>' +
        '</product-title>' + badges + quickAdd +
        '</div>'
      );
    }

    var maxVisible = CARD_CAROUSEL ? 5 : (SECOND_IMAGE_ON_HOVER ? 2 : 1);
    var visible = imgs.slice(0, maxVisible);
    var timeline = visible.map(function (_, i) { return '--slide-' + i; }).join(',');
    var slides = visible.map(function (im, i) {
      var src = imgSrcOf(im);
      var ratio = (im.width && im.height) ? (im.width + ' / ' + im.height) : '1';
      var alt = (im && im.alt) ? im.alt : title;
      var media =
        '<div class="product-media" style="--ratio: ' + ratio + '" data-media-id="' + escapeHtml(String(im.id || i)) + '">' +
        '<img class="product-media__image" src="' + escapeHtml(imageUrl(src, 832)) + '" srcset="' + escapeHtml(mediaSrcset(src)) + '" sizes="(min-width: 750px) 25vw, 50vw" alt="' + escapeHtml(alt) + '" loading="lazy"' + (im.width ? ' width="' + im.width + '"' : '') + (im.height ? ' height="' + im.height + '"' : '') + '>' +
        '</div>';
      // Non-carousel: keep only the first slide visible (hover reveals the next)
      var hidden = (!CARD_CAROUSEL && i !== 0) ? ' hidden' : '';
      return (
        '<slideshow-slide ref="slides[]" aria-hidden="' + (i === 0 ? 'false' : 'true') + '" slide-id="slide-' + i + '"' +
        ' class="product-media-container media-fit product-media-container--image"' +
        ' style="--slideshow-timeline: --slide-' + i + '; --product-media-fit: cover;"' + hidden + '>' + media +
        '</slideshow-slide>'
      );
    }).join('');

    // Hover image from option_value_images.__general.hover (external CDN URL),
    // mirroring snippets/card-gallery.liquid. Activates once the field is on the
    // Meilisearch document; harmless (empty string) until the index includes it.
    // When present it drives the hover and we suppress the legacy slide swap.
    var hoverImage = '';
    try {
      var ovi = hit.option_value_images;
      if (typeof ovi === 'string') ovi = JSON.parse(ovi);
      var oviGeneral = ovi && ovi.__general;
      if (oviGeneral && oviGeneral.hover) hoverImage = frontifySizedUrl(oviGeneral.hover, 1200);
    } catch (e) { /* malformed metafield → no hover */ }
    // Fallback to the product's second image so every card gets the smooth CSS
    // crossfade overlay (mirrors snippets/card-gallery.liquid); this also suppresses
    // the instant slideshow swap below (hoverAttrs is gated on !hoverImage).
    if (SECOND_IMAGE_ON_HOVER && !hoverImage && visible.length > 1) {
      hoverImage = imageUrl(imgSrcOf(visible[1]), 832);
    }
    var hoverOverlay = (SECOND_IMAGE_ON_HOVER && hoverImage)
      ? '<img class="card-gallery__hover-image" src="' + escapeHtml(hoverImage) + '" alt="" role="presentation" aria-hidden="true" loading="lazy">'
      : '';

    var hoverAttrs = SECOND_IMAGE_ON_HOVER && !hoverImage && visible.length > 1 ? ' on:pointerenter="/previewImage" on:pointerleave="/resetImage"' : '';
    var disabled = CARD_CAROUSEL ? '' : ' disabled="true"';
    // Native: arrows shown only when there are more than 2 media
    var arrows = (CARD_CAROUSEL && imgs.length > 2) ? buildArrows() : '';

    return (
      '<div ref="cardGallery" class="card-gallery spacing-style border-style" data-image-ratio="portrait" style="--gallery-aspect-ratio: 4 / 5;"' + hoverAttrs + '>' +
      '<a class="contents" ref="cardGalleryLink" href="' + escapeHtml(url) + '" aria-label="' + escapeHtml(title) + '">' +
      '<slideshow-component ref="slideshow" style="--slideshow-timeline: ' + timeline + ';" initial-slide="0" infinite data-generic-media-size="' + visible.length + '"' + disabled + '>' +
      '<slideshow-container ref="slideshowContainer">' + arrows +
      '<slideshow-slides tabindex="-1" ref="scroller">' + slides + '</slideshow-slides>' +
      '</slideshow-container>' +
      '</slideshow-component>' +
      '</a>' + hoverOverlay + badges + quickAdd +
      '</div>'
    );
  }

  // Real <quick-add-component> markup, mirrors snippets/quick-add + add-to-cart-button
  // so add-to-cart and the multi-variant popup are handled natively by Horizon
  function buildQuickAdd(hit) {
    if (!QUICK_ADD_ENABLED) return '';
    // task 37057 (Fabian, 20.08): remove the control entirely when nothing on this
    // card is buyable — the product carries the PIM "Available" flag 0, or every
    // variant is out of stock. It used to render disabled with an "Out of stock"
    // tooltip (task 45823), which reads as a broken button. Mirrors the gate in
    // snippets/quick-add.liquid.
    if (purchaseBlocked(hit, null) || !isAvailable(hit)) return '';
    var variants = Array.isArray(hit.variants) ? hit.variants : [];
    var variant = null;
    for (var i = 0; i < variants.length; i++) { if (variants[i] && isVariantInStock(variants[i])) { variant = variants[i]; break; } }
    if (!variant && variants.length) variant = variants[0];
    var blocked = purchaseBlocked(hit, variant);
    var canAdd = !!(variant && isVariantInStock(variant)) && !blocked;
    var variantId = variant ? variant.id : '';
    var optionsCount = Array.isArray(hit.options) ? hit.options.length : 1;
    // "add" only for single-variant products, otherwise "choose" opens the popup
    var mode = variants.length <= 1 ? 'add' : 'choose';
    // Single-variant card adds THAT variant directly; if it is blocked there is
    // nothing to choose from either, so drop the control.
    if (mode === 'add' && blocked) return '';
    var addText = (blocked && config.purchaseBlockedText) ? config.purchaseBlockedText : (config.addToCartText || 'Add');
    var chooseText = config.chooseText || 'Choose options';
    var formId = 'QuickAdd-ProductForm-' + (hit.id || '');
    // Image flown to the cart icon by the add-to-cart fly animation
    var variantImg = (variant && variant.image && imgSrcOf(variant.image)) || imgSrcOf(getImageObj(hit));
    var flyMedia = variantImg ? imageUrl(variantImg, 100) : '';

    return (
      // No ref="quickAdd": that ref makes product-card.js prefetch the product page
      // on hover (a request per card scrolled past); without it the popup fetches on click
      '<quick-add-component class="quick-add color-' + escapeHtml(config.quickAddColorScheme || 'scheme-1') + '" data-product-title="' + escapeHtml(getTitle(hit)) + '" data-quick-add-button="' + mode + '" data-product-options-count="' + optionsCount + '">' +
      // data-product-id must be the SHOPIFY product id: atc-modal.js matches the
      // cart-add event against curaprox-atc-modal[data-product-id], which Liquid
      // renders from product.id. Split docs carry the parent id in hit.productId
      // (hit.id is the synthetic "v…" doc id and would never match).
      '<product-form-component data-section-id="ms-collection" data-product-id="' + escapeHtml(String(hit.productId || hit.id || '')) + '" on:submit="/handleSubmit" class="quick-add__product-form-component">' +
      '<div class="visually-hidden" aria-live="assertive" role="status" aria-atomic="true" ref="liveRegion"></div>' +
      '<form action="' + escapeHtml(CART_ADD_URL) + '" accept-charset="UTF-8" method="post" id="' + formId + '" novalidate="novalidate" data-type="add-to-cart-form">' +
      '<input type="hidden" name="form_type" value="product">' +
      '<input type="hidden" name="utf8" value="✓">' +
      '<input type="hidden" name="id" ref="variantId" value="' + escapeHtml(String(variantId)) + '"' + (canAdd ? '' : ' disabled') + '>' +
      '<input type="hidden" name="quantity" value="1">' +
      '<add-to-cart-component ref="addToCartButtonContainer" data-product-variant-media="' + escapeHtml(flyMedia) + '" data-add-to-cart-animation="' + escapeHtml(config.addToCartAnimation || '') + '">' +
      '<button type="submit" name="add" ref="addToCartButton" on:click="/handleClick" aria-label="' + escapeHtml(addText) + '" class="button quick-add__button quick-add__button--add add-to-cart-button"' + (canAdd ? '' : ' disabled title="' + escapeHtml(addText) + '"') + '>' +
      '<span class="add-to-cart-text">' +
      (canAdd ? '<span aria-hidden="true" class="svg-wrapper add-to-cart-icon">' + ADD_TO_CART_ICON + '</span>' : '') +
      '<span class="add-to-cart-text__content is-visually-hidden-mobile"><span><span>' + escapeHtml(addText) + '</span></span></span>' +
      '</span>' +
      '<span class="add-to-cart__added"><span class="svg-wrapper add-to-cart__added-icon">' + ADDED_ICON + '</span></span>' +
      '</button>' +
      '</add-to-cart-component>' +
      '<button class="button quick-add__button quick-add__button--choose add-to-cart-button" type="button" name="add" on:click="quick-add-component/handleClick" aria-label="' + escapeHtml(chooseText) + '">' +
      '<span class="add-to-cart-text">' +
      '<span aria-hidden="true" class="svg-wrapper add-to-cart-icon">' + ADD_TO_CART_ICON + '</span>' +
      '<span class="add-to-cart-text__content is-visually-hidden-mobile"><span><span>' + escapeHtml(chooseText) + '</span></span></span>' +
      '</span>' +
      '</button>' +
      '</form>' +
      '</product-form-component>' +
      '</quick-add-component>'
    );
  }

  function handleizeValue(s) {
    return String(s == null ? '' : s)
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  // \u2500\u2500 Facet displayMode: colour swatches (Figma 1217:20927) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  // A facet whose aico.filter_settings entry has displayMode "swatch" (e.g.
  // filter_farbe) renders a colour-dot pill instead of a checkbox. Values are
  // non-translatable canonical strings (confirmed via the live index: "Blue",
  // "White", "Multicolor"), so the lookup is English-keyed. CSS keyword colours
  // only (never a hardcoded hex, per the design-system rule) \u2014 this represents
  // the PRODUCT's own colour, not UI chrome, so it's outside the .cta/token
  // system on purpose. Extend without editing this file via
  // config.colorSwatchMap (same normalized keys). Unmapped values fall back to
  // a neutral diagonal pattern built from existing theme tokens.
  var SWATCH_FALLBACK = 'repeating-linear-gradient(45deg, var(--color-core-white), var(--color-core-white) 3px, var(--color-neutral-silver) 3px, var(--color-neutral-silver) 6px)';
  var SWATCH_MULTICOLOR = 'conic-gradient(red, orange, yellow, green, blue, indigo, violet, red)';
  var DEFAULT_COLOR_SWATCHES = {
    black: 'black', white: 'white', grey: 'grey', gray: 'grey', silver: 'silver',
    blue: 'blue', navy: 'navy', turquoise: 'turquoise', teal: 'teal', cyan: 'cyan', aqua: 'aqua',
    green: 'green', olive: 'olive', lime: 'lime', mint: 'mediumspringgreen',
    yellow: 'yellow', gold: 'gold', orange: 'orange',
    red: 'red', maroon: 'maroon', pink: 'pink', magenta: 'magenta', fuchsia: 'fuchsia',
    purple: 'purple', violet: 'violet', indigo: 'indigo',
    brown: 'brown', tan: 'tan', beige: 'beige', ivory: 'ivory', cream: 'ivory',
    transparent: 'transparent', clear: 'transparent',
    multicolor: SWATCH_MULTICOLOR, multicolour: SWATCH_MULTICOLOR, rainbow: SWATCH_MULTICOLOR
  };
  var LIGHT_COLOR_SWATCHES = {
    white: true, silver: true, gold: true, yellow: true, ivory: true, cream: true,
    beige: true, transparent: true, clear: true
  };
  // Flavour → dot colour for the Geschmack (group_geschmack) swatch filter. A flavour
  // NAME isn't a colour, so each real taste maps to a representative CSS keyword
  // colour (its tube/flavour colour) — same "keyword colours only, never a hex"
  // rule as the colour map above. Subjective; tweak freely. Keys are handleizeValue()
  // output ("Apple + Aloe Vera" -> "apple-aloe-vera"). Keep in sync with
  // meilisearch-search.js. Unmapped flavours fall back to the neutral pattern.
  var DEFAULT_FLAVOR_SWATCHES = {
    anis: 'yellowgreen',
    'apple-aloe-vera': 'limegreen',
    'blackberry-liquorice': 'indigo',
    'fresh-lime-mint': 'springgreen',
    'lime-mint': 'limegreen',
    mint: 'mediumspringgreen',
    'gin-tonic-persimmon': 'darkorange',
    'grapefruit-bergamot': 'lightcoral',
    'peach-apricot': 'sandybrown',
    'pfirsich-aprikose': 'sandybrown',
    strawberry: 'crimson',
    watermelon: 'linear-gradient(135deg, crimson 0 55%, limegreen 55% 100%)',
    assorted: SWATCH_MULTICOLOR,
    'mixed-flavors': SWATCH_MULTICOLOR
  };
  var COLOR_SWATCH_MAP = Object.assign({}, DEFAULT_COLOR_SWATCHES, DEFAULT_FLAVOR_SWATCHES, config.colorSwatchMap || {});
  function swatchCssFor(value) { return COLOR_SWATCH_MAP[handleizeValue(value)] || SWATCH_FALLBACK; }
  function isLightSwatch(value) { return LIGHT_COLOR_SWATCHES[handleizeValue(value)] === true; }

  // Colour options are usually MERGED (valueMap), so item.value is the synthetic
  // "@@map:" key rather than a colour name — computing the dot from it always hit
  // the fallback pattern. Resolve the dot from the option's raw facet value(s) —
  // the canonical English colour strings ("Blue"/"White"/"Multicolor") — then
  // fall back to value/label so an unmerged or unmapped option still degrades to
  // the neutral pattern.
  function swatchKeyForItem(item) {
    var cands = (item && item.rawValues && item.rawValues.length) ? item.rawValues.slice() : [];
    if (item) { cands.push(item.value, item.label); }
    for (var i = 0; i < cands.length; i++) {
      if (COLOR_SWATCH_MAP[handleizeValue(cands[i])]) return cands[i];
    }
    return cands.length ? cands[0] : '';
  }

  // Zero-count values are re-injected by withZeroCountValues() so the rail never
  // hides an option the shopper's own selection emptied. They must be inert: the
  // `disabled` attribute stops pointer + keyboard activation, and the modifier
  // class greys the row. Mirrors the dormant Horizon path in
  // snippets/list-filter.liquid, which already renders count-0 values disabled.
  function optDisabledAttr(item) { return item.disabled ? ' disabled' : ''; }
  function optDisabledClass(item, base) { return item.disabled ? ' ' + base + '--disabled' : ''; }

  function buildSwatchOptionHtml(field, item) {
    var inputId = 'ms-opt-' + sanitizeId(field) + '-' + sanitizeId(item.value);
    var colorKey = swatchKeyForItem(item);
    var lightClass = isLightSwatch(colorKey) ? ' cura-swatch--light' : '';
    return (
      '<label class="cura-swatch' + lightClass + optDisabledClass(item, 'cura-swatch') + '">' +
      '<input type="checkbox" class="cura-swatch__input" id="' + inputId + '"' +
      ' data-value="' + escapeHtml(item.value) + '"' + (item.isRefined ? ' checked' : '') + optDisabledAttr(item) + '>' +
      '<span class="cura-swatch__dot" style="--swatch: ' + escapeHtml(swatchCssFor(colorKey)) + ';" aria-hidden="true"></span>' +
      '<span class="cura-swatch__label">' + escapeHtml(item.label) + '</span>' +
      '</label>'
    );
  }
  function buildListOptionHtml(field, item) {
    var inputId = 'ms-opt-' + sanitizeId(field) + '-' + sanitizeId(item.value);
    return (
      '<label class="cura-opt' + optDisabledClass(item, 'cura-opt') + '">' +
      '<input type="checkbox" class="cura-opt__input" id="' + inputId + '"' +
      ' data-value="' + escapeHtml(item.value) + '"' + (item.isRefined ? ' checked' : '') + optDisabledAttr(item) + '>' +
      '<span class="cura-opt__box" aria-hidden="true">' + (config.checkmarkIcon || '') + '</span>' +
      '<span class="cura-opt__label">' + escapeHtml(item.label) + '</span>' +
      '<span class="cura-opt__count functional" data-filter-count>' + item.count + '</span>' +
      '</label>'
    );
  }
  // \u2500\u2500 Facet displayMode: softness (Figma 1581:29438, "Softness" group) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  // A plain checkbox list plus a small ascending meter that shows, at a glance,
  // how soft each grade is \u2014 the one facet where the VALUE ITSELF is a scale and
  // the names ("Velvet Soft", "Ultra Soft"\u2026) don't reveal their own order.
  //
  // The ladder cannot be derived from the strings, so it is data, not code: put a
  // `levels` map on the filter's aico.filter_settings entry \u2014
  //
  //   { "meilisearchField": "filter_haerte_der_zahnbuerste", "displayMode": "softness",
  //     "levels": { "Velvet Soft": 1, "Ultra Soft": 2, "Super Soft": 3, "Mega Soft": 4 } }
  //
  // Lookup is case-insensitive and whitespace-trimmed, which also folds the index's
  // "Soft"/"soft" duplicates onto one rung. A value with no mapping renders as an
  // ordinary row with no meter, so an unmapped or newly-added grade degrades to the
  // plain list rather than drawing a misleading number of marks.
  // Figma draws four rungs because its mock lists four grades; the live index has
  // five, so the ladder runs to five rather than collapsing two grades onto one rung
  // (which is what made the meter unreadable — two different grades, same picture).
  var SOFTNESS_MAX_MARKS = 5;

  // A group counts as the softness scale either because the metafield says
  // `displayMode: "softness"`, OR because it is the field the theme knows to be the
  // hardness scale (config.softnessField, default filter_haerte_der_zahnbuerste —
  // renamed from group_haertegrad in the 2026-08 PIM feed). The second route
  // exists so the meter and the ⓘ tooltip work against the CURRENT metafield, which
  // has every filter set to plain "list" — waiting on a config paste to show a tooltip
  // would be silly. An explicit displayMode still wins if someone sets one.
  function isSoftnessGroup(filter) {
    if (!filter) return false;
    if (filter.displayMode === 'softness') return true;
    // Any other explicit mode is a deliberate choice — don't override it.
    if (filter.displayMode && filter.displayMode !== 'list') return false;
    // Compared canonically so the UAE feed's group_haertegrad matches the CH
    // filter_haerte_der_zahnbuerste this config names (see FIELD_ALIASES).
    return !!config.softnessField &&
      canonicalField(filter.meilisearchField) === canonicalField(config.softnessField);
  }

  // The hardness ladder is keyed on the INDEX value ("Ultra Soft"), so a mapped
  // option — whose `value` is a synthetic map key — must be looked up by the raw
  // value it stands for. Without this, translating the Härtegrad group would blank
  // every bristle meter and scramble the soft-to-firm ordering.
  function softnessKey(item) {
    return (item && item.rawValues && item.rawValues.length) ? item.rawValues[0] : (item ? item.value : '');
  }

  function softnessLevel(filter, value) {
    // Levels come from the metafield entry when present, else the theme's own default
    // ladder (config.softnessLevels) so the meter is not blank on an unconfigured store.
    var levels = (filter && filter.levels) || config.softnessLevels;
    if (!levels) return 0;
    var key = String(value == null ? '' : value).trim().toLowerCase();
    for (var name in levels) {
      if (!Object.prototype.hasOwnProperty.call(levels, name)) continue;
      if (String(name).trim().toLowerCase() !== key) continue;
      var n = parseInt(levels[name], 10);
      if (!(n > 0)) return 0;
      return Math.min(n, SOFTNESS_MAX_MARKS);
    }
    return 0;
  }

  function buildSoftnessMeterHtml(level) {
    if (!level) return '';
    var marks = '';
    // One CUREN bristle glyph per rung (Figma 1581:29498). The SVG is filled with
    // `currentColor` so the same asset serves the blue meter and the white icon in
    // the tooltip head.
    var glyph = config.softnessIcon || '';
    for (var i = 0; i < level; i++) marks += '<span class="cura-softness__mark">' + glyph + '</span>';
    // aria-hidden: the grade's NAME is already in the label, so the meter is a
    // visual restatement \u2014 announcing it again would just be noise.
    return '<span class="cura-softness" aria-hidden="true">' + marks + '</span>';
  }

  // The ⓘ trigger + its "Why so soft?" panel (Figma 1581:29438). Both must be
  // siblings inside .cura-fgroup__head: assets/curaprox-collection-filters.js finds
  // the panel with `toggle.parentElement.querySelector`, and the stylesheet positions
  // it against that head (which .cura-fgroup--softness makes `position: relative`).
  // Renders only when there is copy to show, so an unconfigured store gets no
  // dangling icon that opens an empty box.
  function buildSoftnessTipHtml(filter) {
    if (!isSoftnessGroup(filter)) return '';
    var body = config.softnessTipBody;
    if (!body) return '';
    var title = config.softnessTipTitle || '';
    // The ⓘ opens it; the panel's own corner mark is the bristle glyph (Figma), not
    // a second info icon.
    var infoIcon = config.infoIcon || '';
    var featherIcon = config.softnessIcon || '';
    // Blank line in the locale string = paragraph break, so the copy keeps the two
    // paragraphs the design shows without embedding markup in a translation.
    var paragraphs = String(body).split(/\n\s*\n/).map(function (para) {
      return '<p class="cura-softness-tip__body">' + escapeHtml(para.trim()) + '</p>';
    }).join('');
    // The panel is linked by id rather than found as a sibling: on first open it is
    // moved to <body> to escape the rail's clipping (see the click handler), so a
    // DOM-relationship lookup would stop finding it.
    var tipId = 'ms-softness-tip-' + sanitizeId(filter.meilisearchField || 'softness');
    return (
      '<button type="button" class="cura-fgroup__info" data-cura-softness-toggle' +
      ' aria-expanded="false" aria-controls="' + tipId + '"' +
      ' aria-label="' + escapeHtml(title || config.infoLabel || 'Info') + '">' + infoIcon +
      '</button>' +
      '<div class="cura-softness-tip" id="' + tipId + '" data-cura-softness-tip hidden>' +
      '<div class="cura-softness-tip__head">' +
      '<span class="cura-softness-tip__title">' + escapeHtml(title) + '</span>' +
      '<span class="cura-softness-tip__icon" aria-hidden="true">' + featherIcon + '</span>' +
      '</div>' +
      paragraphs +
      '</div>'
    );
  }

  function buildSoftnessOptionHtml(filter, field, item) {
    var inputId = 'ms-opt-' + sanitizeId(field) + '-' + sanitizeId(item.value);
    return (
      '<label class="cura-opt' + optDisabledClass(item, 'cura-opt') + '">' +
      '<input type="checkbox" class="cura-opt__input" id="' + inputId + '"' +
      ' data-value="' + escapeHtml(item.value) + '"' + (item.isRefined ? ' checked' : '') + optDisabledAttr(item) + '>' +
      '<span class="cura-opt__box" aria-hidden="true">' + (config.checkmarkIcon || '') + '</span>' +
      '<span class="cura-opt__label">' + escapeHtml(item.label) + '</span>' +
      buildSoftnessMeterHtml(softnessLevel(filter, softnessKey(item))) +
      '<span class="cura-opt__count functional" data-filter-count>' + item.count + '</span>' +
      '</label>'
    );
  }

  // \u2500\u2500 Facet displayMode: chips (Figma "Chips (anklickbare Werte)", e.g. Inhalt /
  // group_inhalt) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  // Clickable pill chips, multi-select (same connectRefinementList `operator: 'or'`
  // as every other mode), one row per facet value \u2014 structurally identical to
  // buildSwatchOptionHtml (reuses its pill sizing/shape via CSS) minus the colour
  // dot, since chip values are plain text (e.g. "10 ml", "200 ml").
  function buildChipOptionHtml(field, item) {
    var inputId = 'ms-opt-' + sanitizeId(field) + '-' + sanitizeId(item.value);
    return (
      '<label class="cura-chip-opt' + optDisabledClass(item, 'cura-chip-opt') + '">' +
      '<input type="checkbox" class="cura-chip-opt__input" id="' + inputId + '"' +
      ' data-value="' + escapeHtml(item.value) + '"' + (item.isRefined ? ' checked' : '') + optDisabledAttr(item) + '>' +
      '<span class="cura-chip-opt__label">' + escapeHtml(item.label) + '</span>' +
      '<span class="cura-chip-opt__count functional" data-filter-count>' + item.count + '</span>' +
      '</label>'
    );
  }

  // \u2500\u2500 Facet displayMode: radio + segmented \u2014 SINGLE-SELECT modes \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  // Spec (PLP-Collection-Page-Filter-Overview, "Darstellung Filter"):
  //   "radio"     -> Fluoride Level, Chlorhexidine Level
  //                  ("Die meisten Nutzer w\u00e4hlen genau einen Wert.")
  //   "segmented" -> H\u00e4rte der Zahnb\u00fcrste
  //                  ("Bei wenigen Werten wirkt eine Segmentsteuerung sehr hochwertig.")
  // Both are ONE-of-N; they differ only in markup/skin. The underlying Meili widget
  // is still connectRefinementList with operator 'or' (same as every other mode) \u2014
  // single-select is enforced in the change handler by un-refining the previously
  // refined value before refining the clicked one, NOT by switching connector. That
  // keeps applied-chips, the URL sync, the count badge and clear-all working
  // unmodified, since they all read refinement state rather than the DOM.
  //
  // `radio` reuses the existing .cura-opt/.cura-opt--radio skin already shipped for
  // the Sort group (styles at curaprox-collection-filters-styles.liquid:319-354), so
  // it needs no new CSS. `segmented` is the only mode adding styles.
  //
  // Native input[type=radio] + a shared name gives real keyboard semantics (arrow
  // keys move within the group) for free \u2014 worth it over a checkbox we police in JS.
  function isSingleSelectMode(displayMode) {
    return displayMode === 'radio' || displayMode === 'segmented';
  }

  function buildRadioOptionHtml(field, item) {
    var inputId = 'ms-opt-' + sanitizeId(field) + '-' + sanitizeId(item.value);
    return (
      '<label class="cura-opt cura-opt--radio' + optDisabledClass(item, 'cura-opt') + '">' +
      '<input type="radio" class="cura-opt__input" id="' + inputId + '"' +
      ' name="ms-facet-' + sanitizeId(field) + '"' +
      ' data-value="' + escapeHtml(item.value) + '"' + (item.isRefined ? ' checked' : '') + optDisabledAttr(item) + '>' +
      '<span class="cura-opt__radio" aria-hidden="true"></span>' +
      '<span class="cura-opt__label">' + escapeHtml(item.label) + '</span>' +
      '<span class="cura-opt__count functional" data-filter-count>' + item.count + '</span>' +
      '</label>'
    );
  }

  function buildSegmentedOptionHtml(field, item) {
    var inputId = 'ms-opt-' + sanitizeId(field) + '-' + sanitizeId(item.value);
    // Count goes in the title, not a visible node: segments sit side by side on one
    // row, so an inline count would blow the row width out at 4-5 values.
    return (
      '<label class="cura-seg__item' + optDisabledClass(item, 'cura-seg__item') + '" title="' + escapeHtml(item.label + ' (' + item.count + ')') + '">' +
      '<input type="radio" class="cura-seg__input" id="' + inputId + '"' +
      ' name="ms-facet-' + sanitizeId(field) + '"' +
      ' data-value="' + escapeHtml(item.value) + '"' + (item.isRefined ? ' checked' : '') + optDisabledAttr(item) + '>' +
      '<span class="cura-seg__label">' + escapeHtml(item.label) + '</span>' +
      '</label>'
    );
  }

  // \u2500\u2500 Facet displayMode: toggle (Figma "Toggle (Ja/Nein)", e.g. Whitening /
  // group_zahnaufhellung) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  // Unlike every other mode this renders ONE row for the whole facet group (a
  // single on/off switch), not one row per value \u2014 handled as a special case in
  // the render callback below rather than through buildFacetOptionHtml/item-map.
  // Boolean-ish facet data varies by source (confirmed live: group_zahnaufhellung is
  // "yes"/"no"; other facets could ship true/false, Ja/Nein, 1/0), so the "true"
  // row is resolved via a normalized token lookup rather than hardcoded to one
  // language/casing \u2014 extendable without editing this file via
  // config.toggleTrueValues (same normalized-key convention as colorSwatchMap).
  // ON = refine to the true value (only matching products show); OFF = no
  // refinement (both true/false products show), matching the spec's "schneller
  // und verst\u00e4ndlicher Filter" framing of a plain boolean gate.
  var DEFAULT_TOGGLE_TRUE_TOKENS = { 'true': true, yes: true, ja: true, oui: true, si: true, '1': true, on: true };
  var TOGGLE_TRUE_TOKENS = Object.assign({}, DEFAULT_TOGGLE_TRUE_TOKENS, config.toggleTrueValues || {});
  function isToggleTrueValue(value) { return TOGGLE_TRUE_TOKENS[handleizeValue(value)] === true; }

  function buildToggleGroupHtml(filter, field, items) {
    if (!items.length) return '';
    var trueItem = null;
    for (var i = 0; i < items.length; i++) {
      if (isToggleTrueValue(items[i].value)) { trueItem = items[i]; break; }
    }
    // Unmapped boolean-ish value (not in the token lookup): fall back to the
    // first returned value so the switch still targets something refinable,
    // rather than silently rendering nothing.
    if (!trueItem) trueItem = items[0];
    var inputId = 'ms-opt-' + sanitizeId(field) + '-' + sanitizeId(trueItem.value);
    return (
      '<label class="cura-toggle">' +
      '<input type="checkbox" class="cura-toggle__input" id="' + inputId + '"' +
      ' data-value="' + escapeHtml(trueItem.value) + '"' + (trueItem.isRefined ? ' checked' : '') + '>' +
      '<span class="cura-toggle__track" aria-hidden="true"><span class="cura-toggle__thumb"></span></span>' +
      '<span class="cura-toggle__label">' + escapeHtml(getFilterLabel(filter)) + '</span>' +
      '<span class="cura-toggle__count functional" data-filter-count>' + trueItem.count + '</span>' +
      '</label>'
    );
  }

  // Unknown/unrecognised displayMode values fall back to the plain list \u2014 forward
  // compatible with future modes. "toggle" is handled separately (whole-group
  // render, see buildToggleGroupHtml + the render callback) since it isn't a
  // per-item template like the others.
  // NOT implemented: the spec's optional "Range-Slider" for Durchmesser
  // G\u00e4ngigkeit/Wirksamkeit. Those two PIM fields are absent from the live index
  // (facet query over products_fdxamf_rd_myshopify_com returns neither), so a
  // slider could not be exercised against real values \u2014 and the same spec row
  // offers Chips as the alternative for few values ("Bei wenigen Gr\u00f6\u00dfen besser
  // Chips"), which ships today. Revisit once the fields are indexed.
  function buildFacetOptionHtml(filter, field, item) {
    if (filter.displayMode === 'swatch') return buildSwatchOptionHtml(field, item);
    if (filter.displayMode === 'chips') return buildChipOptionHtml(field, item);
    if (filter.displayMode === 'radio') return buildRadioOptionHtml(field, item);
    if (filter.displayMode === 'segmented') return buildSegmentedOptionHtml(field, item);
    if (isSoftnessGroup(filter)) return buildSoftnessOptionHtml(filter, field, item);
    return buildListOptionHtml(field, item);
  }

  // Colour swatches (mirrors snippets/curaprox-card-swatches) from the visual metaobject map
  // Wrap a swatch row's inner HTML in the layout-specific container. Shared by
  // the colour and aroma builders. Keep in sync with the wrapper in
  // snippets/curaprox-card-swatches.liquid and assets/meilisearch-core.js.
  // Lower-cased blob of every collection handle/title the hit belongs to (the
  // index stores `collections: [{handle, title, handle_<lang>, title_<lang>}]`
  // plus flat `collectionTitles[_<lang>]` arrays). Type signal for buildSwatches.
  function collectionHaystack(hit) {
    var parts = [];
    var cols = Array.isArray(hit.collections) ? hit.collections : [];
    cols.forEach(function (c) {
      if (!c || typeof c !== 'object') { if (c) parts.push(String(c)); return; }
      Object.keys(c).forEach(function (k) {
        if (k.indexOf('handle') === 0 || k.indexOf('title') === 0) parts.push(String(c[k] || ''));
      });
    });
    Object.keys(hit).forEach(function (k) {
      if (k.indexOf('collectionTitles') === 0) {
        var v = hit[k];
        if (Array.isArray(v)) parts = parts.concat(v.map(String)); else if (v) parts.push(String(v));
      }
    });
    return parts.join(' ').toLowerCase();
  }

  function swatchRowWrapper(inner, layout) {
    if (!inner) return '';
    if (layout === 'overlay') return '<div class="cpc-swatch-layer"><div class="cpc-swatches">' + inner + '</div></div>';
    return '<div class="cpc-swatches cpc-swatches--inline">' + inner + '</div>';
  }

  function buildSwatches(hit, layout, idSuffix) {
    var svgTpl = config.toothbrushSvg;
    var map = config.visualSwatches || {};
    var options = Array.isArray(hit.options) ? hit.options : [];
    var colorKeys = String(config.colorKeys || 'color').split(',');
    var colorOpt = null;
    for (var i = 0; i < options.length; i++) {
      if (colorKeys.indexOf(String(options[i].name || '').toLowerCase().trim()) !== -1) { colorOpt = options[i]; break; }
    }
    // No colour option (or its SVG template is missing) → try the aroma
    // (flavour) fallback, so flavour-only products (Be You, Kids toothpastes)
    // still get card swatches.
    if (!svgTpl || !colorOpt || !Array.isArray(colorOpt.values)) return buildFallbackSwatches(hit, layout);

    var max = config.swatchMax || 3;

    // Each swatch carries its own variant so clicking it adds THAT colour
    // (client 2026-07-29 — they used to be decorative spans and the click fell
    // through to the card link, which just opened the PDP). Single-option products
    // give `variant.title === "Pink"`; multi-option ones "Pink / Small", hence the
    // segment match. Keep in sync with the same function in meilisearch-core.js
    // (search) and snippets/curaprox-card-swatches.liquid (Liquid cards); the
    // shared click handler is assets/card-swatch-add.js.
    function variantForValue(name) {
      var vs = Array.isArray(hit.variants) ? hit.variants : [];
      for (var i = 0; i < vs.length; i++) {
        var title = String((vs[i] && vs[i].title) || '');
        if (title === name || title.split(' / ').indexOf(name) !== -1) return vs[i];
      }
      return null;
    }


    var resolved = [];
    colorOpt.values.forEach(function (v) {
      var name = (v && typeof v === 'object') ? (v.value || v.name || v.title || '') : v;
      var vh = handleizeValue(name);
      if (vh && map[vh]) resolved.push({ vh: vh, vis: map[vh], name: name, variant: variantForValue(name) });
    });
    // Split docs: hit.options still lists EVERY product option value, but the
    // card stands for one group — keep only values backed by a group variant,
    // or the row fills with inert spans plus a bogus "+N" for sibling cards.
    if (isSplitHit(hit)) {
      resolved = resolved.filter(function (s) { return s.variant && s.variant.id; });
      // A one-variant group IS its single value — a lone self-referential swatch
      // is noise, the card image already shows it.
      if (resolved.length <= 1) return '';
    }
    // Colour option present but no value maps to a `visual` entry → still try
    // the aroma fallback before giving up.
    if (!resolved.length) return buildFallbackSwatches(hit, layout);

    // ── PDP-parity type detection (mirrors variant-toothbrush-swatches.liquid;
    // token lists arrive translated-per-store via the config). Toothbrush-ness
    // from the product type; refill / head from tags + title tokens.
    function anyToken(tokens, haystack) {
      return String(tokens || '').split(',').some(function (t) {
        t = t.trim();
        return t && haystack.indexOf(t) !== -1;
      });
    }
    // Meili hits carry no Shopify productType — the type signal in the index is
    // `group_produkt_type` (PIM taxonomy: "Manual Toothbrush", "Electric
    // Toothbrush", "Teething Ring", …); getSubtitle stays in the mix for
    // robustness if productType fields get indexed later.
    var gpt = hit.group_produkt_type;
    if (!Array.isArray(gpt)) gpt = gpt ? [gpt] : [];
    var typeNorm = (String(getSubtitle(hit) || '') + ' ' + gpt.join(' ')).toLowerCase();
    var titleNorm = String(getTitle(hit) || '').toLowerCase();
    // `group_produkt_type` is only indexed for products whose PIM record carries
    // that taxonomy attribute — on UAE none of the toothbrushes do and on CH only
    // part of them (verified 2026-08-20: CS 12460 Velvet, CS 5460 and the Rainbow
    // brush heads all lacked it and rendered as plain colour discs, Jan Krammer's
    // PLP review). The hit's `collections[]` (handle + title, every locale) is
    // always present, so it joins the type haystack: a product filed under
    // "manual-toothbrushes" / "Zahnbürsten" IS a toothbrush. Only tokens of 3+
    // chars scan the collection names — the 2-char "tb" type code would
    // false-match inside arbitrary collection titles.
    var collNorm = collectionHaystack(hit);
    var longTbTokens = String(config.tbTypeTokens || 'toothbrush').split(',').filter(function (t) { return t.trim().length >= 3; }).join(',');
    var isTB = anyToken(config.tbTypeTokens || 'tb,toothbrush', typeNorm) || anyToken(longTbTokens, collNorm);
    var isHead = isTB && anyToken(config.headTitleTokens, titleNorm);
    // Unlike the Liquid snippet, refill detection is NOT gated on !isTB: the PIM
    // taxonomy files travel refills under "Specialized Toothbrush", so the
    // "type is Other" gate that works on Shopify product.type never fires here.
    var tags = hit.tags;
    if (typeof tags === 'string') tags = tags.split(',');
    if (!Array.isArray(tags)) tags = [];
    var isRefill = tags.some(function (t) { return String(t).toLowerCase().indexOf('refill-brushhead') !== -1; });
    if (!isRefill) isRefill = anyToken(config.refillTitleTokens, titleNorm);

    // Band colour for one part of a multi-colour value ("Dark Blue" out of
    // "White/Dark Blue/Pink"): exact single-colour entry first, else the first
    // entry whose handle starts with the part (same fallback as the PDP), else
    // neutral grey.
    function partColor(part) {
      var ph = handleizeValue(String(part).trim());
      if (ph && map[ph] && map[ph].body) return map[ph].body;
      var prefix = ph + '-';
      for (var k in map) {
        if (k.indexOf(prefix) === 0 && map[k].body) return map[k].body;
      }
      return '#d9d9d9';
    }

    // Visual for one swatch — the PDP priority tree (uploaded image > split disc
    // > head svg > toothbrush svg > colour disc). Keep in sync with
    // snippets/curaprox-card-swatches.liquid and meilisearch-core.js.
    function swatchVisual(s, idx) {
      var vars = '';
      if (s.vis.img) {
        vars = '--toothbrush-image:url(' + s.vis.img + ');';
        return { vars: vars, html: '<span class="cpc-swatch__img"></span>' };
      }
      var parts = String(s.name || '').split('/');
      if (parts.length >= 3 || (parts.length === 2 && isHead)) {
        var n = Math.min(parts.length, 3);
        for (var i = 0; i < n; i++) vars += '--trio-' + (i + 1) + ':' + partColor(parts[i]) + ';';
        var duo = parts.length === 2 ? ' cpc-swatch__trio--duo' : '';
        return { vars: vars, html: '<span class="cpc-swatch__trio' + duo + '"></span>' };
      }
      if (isRefill) {
        if (s.vis.body) vars += '--body:' + s.vis.body + ';';
        return { vars: vars, html: config.headSvg || '' };
      }
      if (isTB) {
        if (s.vis.body) vars += '--body:' + s.vis.body + ';';
        if (s.vis.bristles) vars += '--bristles:' + s.vis.bristles + ';';
        return { vars: vars, html: svgTpl.split('__UID__').join(s.vh + '-' + idSuffix + '-' + idx) };
      }
      vars = '--disc-color:' + (s.vis.body || '#d9d9d9') + ';';
      return { vars: vars, html: '<span class="cpc-swatch__disc"></span>' };
    }

    var inner = resolved.slice(0, max).map(function (s, idx) {
      var sv = swatchVisual(s, idx);
      var vars = sv.vars;
      var svg = sv.html;
      var visual = '<span class="cpc-swatch" style="' + escapeHtml(vars) + '" aria-hidden="true">' + svg + '</span>';

      // No variant resolved for this option value → keep the inert span rather
      // than an add button that would do nothing.
      if (!s.variant || !s.variant.id) return visual;

      var vid = String(s.variant.id);
      // Swatch now PREVIEWS the colour on the card (image swap) instead of adding
      // to cart — assets/card-swatch-add.js reads data-image + data-hover-image +
      // data-variant-url. Meili cards render positional slide-ids (not media ids),
      // so the handler swaps the visible <img> src to data-image directly.
      // Per-colour images from the OVI metafield (PDP source) take priority; the
      // Shopify variant image is the fallback. data-hover-image = colour's 2nd image.
      // Per-colour images come from the OVI metafield, which reaches the index
      // as `metafield_custom_fields_option_value_images` via the filter app's
      // "Extra Included Metafields" (configured per store, see oviData). Without
      // it oviVariantImages returns [] and the pick keeps its own image on hover.
      var swOvi = oviVariantImages(hit, s.variant, s.name);
      var swImg = swOvi[0] || ((s.variant.image && imgSrcOf(s.variant.image)) ? imageUrl(imgSrcOf(s.variant.image), 832) : '');
      // Per-colour second image ONLY. No product-wide fallback here: after a pick
      // the hover must not flip the card to another colour's image (Jan Krammer,
      // 2026-08-21); card-swatch-add.js keeps the picked image when this is blank.
      var swHover = swOvi[1] || '';
      var swUrl = ROOT_PATH + 'products/' + getHandle(hit) + '?variant=' + encodeURIComponent(vid);
      var showLabel = (config.showText || 'Show') + ': ' + getTitle(hit) + ' — ' + s.name;
      // The click target IS the swatch — do NOT wrap it in a <button>. This markup
      // ships in a JS asset while its styling ships in the CSS bundle, so a wrapper
      // that needs new CSS collapses to a 16x6 box (empty grey circles) when the two
      // land out of sync. Keep in sync with snippets/curaprox-card-swatches.liquid.
      return (
        '<span class="cpc-swatch" style="' + escapeHtml(vars) + '"' +
        ' data-cpc-swatch-add data-variant-id="' + escapeHtml(vid) + '"' +
        ' data-image="' + escapeHtml(swImg) + '"' +
        ' data-hover-image="' + escapeHtml(swHover) + '"' +
        ' data-variant-url="' + escapeHtml(swUrl) + '"' +
        ' role="button" tabindex="0"' +
        ' aria-pressed="false"' +
        ' aria-label="' + escapeHtml(showLabel) + '"' +
        (!isVariantInStock(s.variant) || purchaseBlocked(hit, s.variant) ? ' aria-disabled="true"' : '') +
        '>' + svg + '</span>'
      );
    }).join('');

    if (resolved.length > max) {
      var url = ROOT_PATH + 'products/' + getHandle(hit);
      // aria-label leads with the visible "+N" (WCAG 2.5.3 label-in-name), then the title.
      // `data-cpc-swatch-more` → assets/card-swatch-add.js opens the quick-add
      // chooser instead of navigating; the href stays as a no-JS fallback.
      inner += '<a class="cpc-swatch-more functional" data-cpc-swatch-more href="' + escapeHtml(url) + '" aria-label="' + escapeHtml('+' + (resolved.length - max) + ' ' + getTitle(hit)) + '">+' + (resolved.length - max) + '</a>';
    }

    return swatchRowWrapper(inner, layout);
  }

  // Aroma (flavour) swatch row — the fallback for flavour-only products (Be You,
  // Kids toothpastes) that carry no colour option. Renders the SAME `.cpc-swatch`
  // add-to-cart contract as buildSwatches (card-swatch-add.js reads
  // data-cpc-swatch-add / data-variant-id) with a static PDP-parity aroma visual
  // (`--aroma` ring + colour, masked `--aroma-icon`). Keep in sync with the aroma
  // branch of snippets/curaprox-card-swatches.liquid + assets/meilisearch-core.js.
  function buildAromaSwatches(hit, layout) {
    var map = config.aromaSwatches || {};
    var aromaKeys = String(config.aromaKeys || '').split(',').map(function (k) { return k.trim().toLowerCase(); }).filter(Boolean);
    if (!aromaKeys.length) return '';
    var options = Array.isArray(hit.options) ? hit.options : [];
    var aromaOpt = null;
    for (var i = 0; i < options.length; i++) {
      if (aromaKeys.indexOf(String(options[i].name || '').toLowerCase().trim()) !== -1) { aromaOpt = options[i]; break; }
    }
    if (!aromaOpt || !Array.isArray(aromaOpt.values)) return '';

    var max = config.swatchMax || 3;

    function variantForValue(name) {
      var vs = Array.isArray(hit.variants) ? hit.variants : [];
      for (var i = 0; i < vs.length; i++) {
        var title = String((vs[i] && vs[i].title) || '');
        if (title === name || title.split(' / ').indexOf(name) !== -1) return vs[i];
      }
      return null;
    }


    var resolved = [];
    aromaOpt.values.forEach(function (v) {
      var name = (v && typeof v === 'object') ? (v.value || v.name || v.title || '') : v;
      var ah = handleizeValue(name);
      if (ah && map[ah]) resolved.push({ ah: ah, aroma: map[ah], name: name, variant: variantForValue(name) });
    });
    // Split docs: same group-scoping as buildSwatches — hit.options spans the
    // whole product, the card only its group.
    if (isSplitHit(hit)) {
      resolved = resolved.filter(function (s) { return s.variant && s.variant.id; });
      if (resolved.length <= 1) return '';
    }
    if (!resolved.length) return '';

    var inner = resolved.slice(0, max).map(function (s) {
      var vars = '--aroma:' + (s.aroma.colour || '#d9d9d9') + ';';
      if (s.aroma.bg) vars += '--aroma-bg:' + s.aroma.bg + ';';
      if (s.aroma.icon) vars += '--aroma-icon:url(' + s.aroma.icon + ');';
      var iconHtml = s.aroma.icon ? '<span class="cpc-swatch__aroma-icon"></span>' : '';
      var visual = '<span class="cpc-swatch__aroma">' + iconHtml + '</span>';

      // No variant resolved → inert span (matches the colour path).
      if (!s.variant || !s.variant.id) {
        return '<span class="cpc-swatch cpc-swatch--aroma" style="' + escapeHtml(vars) + '" aria-hidden="true">' + visual + '</span>';
      }
      var vid = String(s.variant.id);
      var swOvi = oviVariantImages(hit, s.variant, s.name);
      var swImg = swOvi[0] || ((s.variant.image && imgSrcOf(s.variant.image)) ? imageUrl(imgSrcOf(s.variant.image), 832) : '');
      // Per-colour second image ONLY. No product-wide fallback here: after a pick
      // the hover must not flip the card to another colour's image (Jan Krammer,
      // 2026-08-21); card-swatch-add.js keeps the picked image when this is blank.
      var swHover = swOvi[1] || '';
      var swUrl = ROOT_PATH + 'products/' + getHandle(hit) + '?variant=' + encodeURIComponent(vid);
      var showLabel = (config.showText || 'Show') + ': ' + getTitle(hit) + ' — ' + s.name;
      return (
        '<span class="cpc-swatch cpc-swatch--aroma" style="' + escapeHtml(vars) + '"' +
        ' data-cpc-swatch-add data-variant-id="' + escapeHtml(vid) + '"' +
        ' data-image="' + escapeHtml(swImg) + '"' +
        ' data-hover-image="' + escapeHtml(swHover) + '"' +
        ' data-variant-url="' + escapeHtml(swUrl) + '"' +
        ' role="button" tabindex="0"' +
        ' aria-pressed="false"' +
        ' aria-label="' + escapeHtml(showLabel) + '"' +
        (!isVariantInStock(s.variant) || purchaseBlocked(hit, s.variant) ? ' aria-disabled="true"' : '') +
        '>' + visual + '</span>'
      );
    }).join('');

    if (resolved.length > max) {
      var url = ROOT_PATH + 'products/' + getHandle(hit);
      inner += '<a class="cpc-swatch-more functional" data-cpc-swatch-more href="' + escapeHtml(url) + '" aria-label="' + escapeHtml('+' + (resolved.length - max) + ' ' + getTitle(hit)) + '">+' + (resolved.length - max) + '</a>';
    }

    return swatchRowWrapper(inner, layout);
  }

  // Inner HTML of a <product-card> (the wrapper element is created by renderHits)
  // Non-colour swatch rows, tried in order: aroma (flavour) → fluoride pills →
  // size chips. A product carries at most one of these option families (Be You /
  // Kids pastes → aroma, Enzycal → fluoride, CPS interdental → size), so the
  // first row that resolves wins. Client 2026-08-20 (Jan Krammer): cards must
  // show the same variant icons the PDP shows — fluoride pills for Enzycal, the
  // sizes for CPS brushes. Keep in sync with snippets/curaprox-card-swatches.liquid.
  function buildFallbackSwatches(hit, layout) {
    return buildAromaSwatches(hit, layout) || buildFluorideSwatches(hit, layout) || buildSizeSwatches(hit, layout) || buildLabelSwatches(hit, layout);
  }

  // Finds the first product option whose (lower-cased, trimmed) name is in the
  // comma-separated alias list. Single-value options are skipped — the PDP only
  // dispatches a swatch renderer when an option has more than one value, and a
  // lone chip on a card is noise.
  function optionByKeys(hit, keysCsv) {
    var keys = String(keysCsv || '').split(',').map(function (k) { return k.trim().toLowerCase(); }).filter(Boolean);
    if (!keys.length) return null;
    var options = Array.isArray(hit.options) ? hit.options : [];
    for (var i = 0; i < options.length; i++) {
      if (keys.indexOf(String(options[i].name || '').toLowerCase().trim()) !== -1) {
        return (Array.isArray(options[i].values) && options[i].values.length > 1) ? options[i] : null;
      }
    }
    return null;
  }

  // Generic option row: every value of `opt` becomes a `.cpc-swatch` carrying the
  // same preview contract as the colour path (data-cpc-swatch-add, data-image,
  // data-variant-url — assets/card-swatch-add.js), with the visual supplied by
  // `visualFor(valueName)` → { cls, vars, html } (null skips the value). Values
  // beyond `max` collapse into the "+N" pill that opens the quick-add chooser.
  function buildOptionSwatchRow(hit, layout, opt, max, visualFor) {
    function variantForValue(name) {
      var vs = Array.isArray(hit.variants) ? hit.variants : [];
      for (var i = 0; i < vs.length; i++) {
        var title = String((vs[i] && vs[i].title) || '');
        if (title === name || title.split(' / ').indexOf(name) !== -1) return vs[i];
      }
      return null;
    }

    var resolved = [];
    opt.values.forEach(function (v) {
      var name = (v && typeof v === 'object') ? (v.value || v.name || v.title || '') : v;
      var visual = name ? visualFor(String(name)) : null;
      if (visual) resolved.push({ name: String(name), visual: visual, variant: variantForValue(String(name)) });
    });
    // Split docs: same group-scoping as buildSwatches — keep only values backed
    // by a group variant; a one-variant group is its single value.
    if (isSplitHit(hit)) {
      resolved = resolved.filter(function (s) { return s.variant && s.variant.id; });
      if (resolved.length <= 1) return '';
    }
    if (!resolved.length) return '';

    var inner = resolved.slice(0, max).map(function (s) {
      var cls = 'cpc-swatch ' + s.visual.cls;
      var vars = s.visual.vars || '';
      if (!s.variant || !s.variant.id) {
        return '<span class="' + cls + '" style="' + escapeHtml(vars) + '" aria-hidden="true">' + s.visual.html + '</span>';
      }
      var vid = String(s.variant.id);
      var swOvi = oviVariantImages(hit, s.variant, s.name);
      var swImg = swOvi[0] || ((s.variant.image && imgSrcOf(s.variant.image)) ? imageUrl(imgSrcOf(s.variant.image), 832) : '');
      // Per-colour second image ONLY. No product-wide fallback here: after a pick
      // the hover must not flip the card to another colour's image (Jan Krammer,
      // 2026-08-21); card-swatch-add.js keeps the picked image when this is blank.
      var swHover = swOvi[1] || '';
      var swUrl = ROOT_PATH + 'products/' + getHandle(hit) + '?variant=' + encodeURIComponent(vid);
      var showLabel = (config.showText || 'Show') + ': ' + getTitle(hit) + ' — ' + s.name;
      return (
        '<span class="' + cls + '" style="' + escapeHtml(vars) + '"' +
        ' data-cpc-swatch-add data-variant-id="' + escapeHtml(vid) + '"' +
        ' data-image="' + escapeHtml(swImg) + '"' +
        ' data-hover-image="' + escapeHtml(swHover) + '"' +
        ' data-variant-url="' + escapeHtml(swUrl) + '"' +
        ' role="button" tabindex="0"' +
        ' aria-pressed="false"' +
        ' aria-label="' + escapeHtml(showLabel) + '"' +
        (!isVariantInStock(s.variant) || purchaseBlocked(hit, s.variant) ? ' aria-disabled="true"' : '') +
        '>' + s.visual.html + '</span>'
      );
    }).join('');

    if (resolved.length > max) {
      var url = ROOT_PATH + 'products/' + getHandle(hit);
      inner += '<a class="cpc-swatch-more functional" data-cpc-swatch-more href="' + escapeHtml(url) + '" aria-label="' + escapeHtml('+' + (resolved.length - max) + ' ' + getTitle(hit)) + '">+' + (resolved.length - max) + '</a>';
    }

    return swatchRowWrapper(inner, layout);
  }

  // Fluoride level → artwork key. Token-based like variant-fluoride-swatches.liquid
  // (the PIM values carry the ppm figure: "950 ppm", "1450 ppm", "Zero Fluoride");
  // 1450 is tested before 950 so a "1450 (950 for kids)"-style value can't match
  // the wrong pill. Unknown levels fall back to a text chip, as the PDP falls back
  // to its text pill.
  function fluorideArtKey(name) {
    var n = String(name || '').toLowerCase();
    if (n.indexOf('1450') !== -1) return '1450';
    if (n.indexOf('950') !== -1) return '950';
    if (/(^|[^a-z])(zero|ohne|sans|senza)([^a-z]|$)/.test(n)) return 'zero';
    return '';
  }

  // Text chip visual — shared by unmapped fluoride levels and the size path.
  function chipVisual(label) {
    return { cls: 'cpc-swatch--chip', vars: '', html: '<span class="cpc-swatch__chip-text">' + escapeHtml(label) + '</span>' };
  }

  // Fluoride pills (Enzycal 950 / Zero / 1450): the PDP's brand artwork
  // (assets/fluoride-pill-*.svg, delivered via config.fluorideArt) at card height.
  // aria-pressed / hover swap to the filled "selected" artwork like the PDP.
  function buildFluorideSwatches(hit, layout) {
    var opt = optionByKeys(hit, config.fluorideKeys);
    var art = config.fluorideArt || {};
    if (!opt) return '';
    return buildOptionSwatchRow(hit, layout, opt, config.swatchMax || 3, function (name) {
      var key = fluorideArtKey(name);
      var pair = key && art[key];
      if (!pair || !pair[0]) return chipVisual(name);
      return {
        cls: 'cpc-swatch--pill',
        vars: '--fluoride-art:url(' + pair[0] + ');--fluoride-art-selected:url(' + (pair[1] || pair[0]) + ');',
        html: '<span class="cpc-swatch__pill-art"></span>'
      };
    });
  }

  // Size chip label: the PIM size values read "CPS 06, 0.6mm, Green" — the first
  // comma segment is the designation the PDP shows (its variant_name metafield
  // holds the same "CPS 06"). The family word the card title already carries
  // ("CPS" in "CPS Prime Start") is dropped so five chips fit the row: "06 07 08
  // 09 011". The full value stays in the aria-label. Keep in sync with the size
  // branch of snippets/curaprox-card-swatches.liquid.
  function sizeChipLabel(name, title) {
    var seg = String(name || '').split(',')[0].trim();
    var words = seg.split(/\s+/);
    if (words.length > 1) {
      var titleWords = String(title || '').toLowerCase().split(/\s+/);
      if (titleWords.indexOf(words[0].toLowerCase()) !== -1) seg = words.slice(1).join(' ');
    }
    return seg;
  }

  // Size chips (CPS interdental brushes): text chips, up to 5 in the desktop row
  // (short labels) and 3 in the mobile overlay — the row has to share the image
  // with the quick-add there.
  function buildSizeSwatches(hit, layout) {
    var opt = optionByKeys(hit, config.sizeKeys);
    if (!opt) return '';
    var title = getTitle(hit);
    var max = (layout === 'overlay') ? 3 : (config.sizeChipMax || 5);
    return buildOptionSwatchRow(hit, layout, opt, max, function (name) {
      var label = sizeChipLabel(name, title);
      return label ? chipVisual(label) : null;
    });
  }

  // Label chips (Perio Plus mouthwash line, Jan Krammer 2026-08-26): option
  // families listed in config.chipKeys whose values are short names ("Zero",
  // "Forte", ...). Same text chip as the size row, raw value as the label.
  function buildLabelSwatches(hit, layout) {
    var opt = optionByKeys(hit, config.chipKeys);
    if (!opt) return '';
    var max = (layout === 'overlay') ? 3 : (config.sizeChipMax || 5);
    return buildOptionSwatchRow(hit, layout, opt, max, function (name) {
      var label = String(name || '').trim();
      return label ? chipVisual(label) : null;
    });
  }

  function buildCardInner(hit) {
    var title = getTitle(hit);
    var url = ROOT_PATH + 'products/' + getHandle(hit);
    // Split card → PDP opens preselected on the group's variant. Unsplit cards
    // keep the bare product URL.
    if (isSplitHit(hit)) {
      var sv = splitVariant(hit);
      if (sv && sv.id) url += '?variant=' + encodeURIComponent(String(sv.id));
    }
    var subtitle = getSubtitle(hit);
    var price = getPrice(hit);
    var priceHtml = (price.amount != null && isFinite(Number(price.amount))) ? moneyHtml(price.amount, price.currency) : '';

    return (
      // id is required: product-card.js navigateToProduct() bails without it, so
      // clicking the card (text/image, incl. the no-image placeholder) wouldn't navigate
      '<a id="ms-card-link-' + escapeHtml(String(hit.id == null ? '' : hit.id)) + '" href="' + escapeHtml(url) + '" class="product-card__link" ref="productCardLink"><span class="visually-hidden">' + escapeHtml(title) + '</span></a>' +
      // Same classes + inline CSS vars as the native content wrapper (paddings 0, gap 0)
      '<div class="product-card__content layout-panel-flex layout-panel-flex--column product-grid__card spacing-style border-style gap-style" style="--padding-block-start: 0px; --padding-block-end: 0px; --padding-inline-start: 0px; --padding-inline-end: 0px; --product-card-gap: 0px;">' +
      // Native DOM order: gallery, badges, mobile swatch overlay, then cpc-info
      buildGallery(hit, title, url) +
      renderBadgesHtml(hit) +
      buildSwatches(hit, 'overlay', 'm') +
      '<div class="cpc-info">' +
      '<div class="cpc-info__headings">' +
      '<p class="cpc-info__title s2 bold">' + escapeHtml(title) + '</p>' +
      (subtitle ? '<p class="cpc-info__subtitle s4">' + escapeHtml(subtitle) + '</p>' : '') +
      '</div>' +
      '<div class="cpc-info__meta">' +
      '<div class="cpc-info__meta-left">' +
      '<p class="cpc-info__price s3">' + priceHtml + '</p>' +
      renderRatingHtml(hit) +
      '</div>' +
      buildSwatches(hit, 'inline', 'd') +
      '</div>' +
      '</div>' +
      '</div>'
    );
  }

  // The <ul ref="grid" class="product-grid"> is server-rendered by
  // snippets/product-grid.liquid, but its `{% if products.size == 0 %}` branch
  // (~line 118) renders ONLY the .main-collection-grid__empty message and skips the
  // <ul> entirely when the Shopify collection itself has no products — even when
  // Meilisearch still has hits for it (the two can drift out of sync). The
  // #ResultsList wrapper and its immediate child div (both carrying the section's
  // --grid-column--desktop/mobile, --product-grid-gap-* and container-type inline
  // CSS custom properties) sit OUTSIDE that conditional and are always rendered, so
  // unlike ensureGrid() in meilisearch-search.js — which sometimes has to rebuild
  // the whole #ResultsList wrapper from scratch, including re-applying
  // --grid-column--desktop/mobile (a past bug came from omitting those) — we only
  // need to build the missing <ul> shell and drop it in place of the empty-state
  // message. Column COUNT (3-up desktop, 4-up @1920) comes from the global
  // `body:has(.collection-toolbar) .product-grid--grid` rule
  // (snippets/collection-toolbar-styles.liquid), keyed off the bare
  // `product-grid--grid` class, so no section-id-scoped class is required here
  // (same simplification meilisearch-search.js's ensureGrid() makes).
  function ensureGrid() {
    var grid = document.querySelector('#ResultsList ul.product-grid') || document.querySelector('ul.product-grid');
    if (grid) return grid;
    var resultsList = document.getElementById('ResultsList');
    var container = resultsList && resultsList.firstElementChild;
    if (!container) return null;
    var empty = container.querySelector('.main-collection-grid__empty');
    if (empty) empty.remove();
    var ul = document.createElement('ul');
    ul.className = 'product-grid product-grid--grid';
    ul.setAttribute('data-testid', 'product-grid');
    ul.setAttribute('product-grid-view', 'default');
    ul.setAttribute('ref', 'grid');
    ul.setAttribute('role', 'list');
    ul.style.setProperty('--mobile-columns', '2');
    container.appendChild(ul);
    return ul;
  }

  // Skeleton placeholders shown while Meilisearch is fetching; the first render replaces them
  function showSkeletons() {
    var grid = ensureGrid();
    if (!grid || grid.querySelector('.ms-skeleton-item')) return;
    var n = productsPerPage || 12;
    var cell =
      '<li class="product-grid__item ms-skeleton-item" aria-hidden="true">' +
      '<div class="ms-skel-card">' +
      '<span class="ms-skel-img"></span>' +
      '<span class="ms-skel-line ms-skel-line--title"></span>' +
      '<span class="ms-skel-line ms-skel-line--price"></span>' +
      '</div>' +
      '</li>';
    var html = '';
    for (var i = 0; i < n; i++) html += cell;
    grid.insertAdjacentHTML('beforeend', html);
  }

  // InstantSearch bootstrap
  var _initialized = false;
  function checkAndInit() {
    if (_initialized) return true;
    if (typeof window.instantsearch !== 'undefined' && typeof instantMeiliSearch !== 'undefined') {
      _initialized = true;
      startSearch();
      return true;
    }
    return false;
  }
  function initSearch() {
    if (checkAndInit()) return;
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (checkAndInit() || attempts > 50) {
        clearInterval(timer);
        if (attempts > 50) console.error('[ms-collection] InstantSearch libraries failed to load.');
      }
    }, 100);
  }

  function startSearch() {
    var client = instantMeiliSearch(HOST, API_KEY, {
      primaryKey: 'id',
      keepZeroFacets: false
    });

    // ── Next-page prefetch ───────────────────────────────────────────────────────
    // Warm the adapter's in-memory response cache with the NEXT page before the user
    // clicks "Load more" (or right after each render, on idle), so the click resolves
    // from cache with no network round-trip. instant-meilisearch keys its cache on the
    // stringified request batch and never auto-clears it, so replaying the last batch
    // with the hits page incremented stores the exact entry connectInfiniteHits will
    // look up on showMore(). Fully best-effort: a cache miss just falls back to the
    // normal fetch, so there is no behaviour change if any assumption here is off.
    var _lastSearchRequests = null;
    var _rawSearch = null;
    (function () {
      var sc = client.searchClient;
      if (!sc || typeof sc.search !== 'function') return;
      _rawSearch = sc.search.bind(sc);
      sc.search = function (requests) {
        _lastSearchRequests = requests;   // capture InstantSearch's real batch
        return _rawSearch(requests);
      };
    })();

    var baseFilters = [];
    if (FILTER_BY_COLLECTION && collectionId) baseFilters.push('collections.id = ' + collectionId);
    if (!showOutOfStock) baseFilters.push('(totalInventory > 0 OR variants.inventoryPolicy = "CONTINUE")');

    var search = window.instantsearch({
      indexName: INDEX,
      searchClient: client.searchClient,
      insights: false,
      // Sync applied filters + sort to the URL, keyed by the raw meilisearchField
      // names (e.g. ?group_inhalt=foo,bar&sort=price-ascending)
      routing: {
        stateMapping: {
          stateToRoute: function (uiState) {
            var idx = uiState[INDEX] || {};
            var route = {};
            if (idx.refinementList) {
              Object.keys(idx.refinementList).forEach(function (attr) {
                if (attr === CATEGORY_FIELD) return; // category is written as ?category= handles below
                var vals = idx.refinementList[attr];
                if (vals && vals.length) route[attr] = vals.join(',');
              });
            }
            // Only an explicit pick is written, so the default leaves the URL clean.
            // Read off the radio, not uiState.sortBy — InstantSearch drops sortBy when
            // it equals the bare index, which is exactly what "Relevance" refines to.
            if (_sortRadio) route.sort = _sortRadio;
            // Price range → ?price=min:max (either side may be blank for open-ended).
            // Written under its own key rather than through refinementList, whose
            // routeToState treats every unreserved key as a comma-joined value list.
            if (idx.range && idx.range[PRICE_FIELD_FILTER]) {
              route.price = idx.range[PRICE_FIELD_FILTER];
            }
            // Category drill path as collection handles (matching stays by id internally)
            if (_catPath && _catPath.length) {
              route.category = _catPath.map(function (n) { return n.handle; }).join(',');
            }
            // Page is not written to the URL: a refreshed ?page=N would strand the user
            return route;
          },
          routeToState: function (route) {
            var reserved = { sort: true, page: true, category: true, price: true };
            var refinementList = {};
            Object.keys(route).forEach(function (key) {
              if (reserved[key] || !route[key]) return;
              refinementList[key] = String(route[key]).split(',');
            });
            // Restore the category refinement from ?category= handles
            if (route.category) {
              var ids = String(route.category).split(',').map(function (h) {
                var n = _catByHandle[h];
                return n ? catKey(n) : null;
              }).filter(Boolean);
              if (CATEGORY_MODE === 'replace' && ids.length) ids = [ids[ids.length - 1]];
              if (ids.length) refinementList[CATEGORY_FIELD] = ids;
            }
            var state = {};
            if (Object.keys(refinementList).length) state.refinementList = refinementList;
            if (route.price) {
              state.range = {};
              state.range[PRICE_FIELD_FILTER] = String(route.price);
            }
            // Always set sortBy: with no ?sort the grid must land on DEFAULT_SORT, not
            // on the bare index. Mirroring it onto the radio keeps Back/Forward in sync.
            _sortRadio = SORT_ROUTES.indexOf(route.sort) !== -1 ? route.sort : null;
            state.sortBy = sortValueFor(_sortRadio);
            // page stays reserved (not read as a facet) but is never applied
            var uiState = {};
            uiState[INDEX] = state;
            return uiState;
          }
        }
      }
    });

    var widgets = [];

    // Scroll to top when the query changes (filter / sort / chip / clear), not on append
    var _scrollPending = false;
    function scrollToResultsTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    search.on('render', function () {
      if (!_scrollPending) return;
      _scrollPending = false;
      requestAnimationFrame(function () { requestAnimationFrame(scrollToResultsTop); });
    });

    // ── Back-navigation restore ───────────────────────────────────────────────
    // Pages loaded through "Load more" live only in memory: `page` is deliberately
    // kept out of the URL (see stateToRoute above), so filters survived Back but the
    // grid rebuilt at page 0 and dropped the reader at the top of the list.
    //
    // Two halves, because one does not imply the other:
    //  1. HITS — InstantSearch's own sessionStorage cache replays every page that was
    //     loaded for this exact uiState. Keyed on the state MINUS page, so any filter
    //     or sort change misses the cache and falls through to a normal fresh search.
    //  2. SCROLL — the grid is client-rendered, so by the time the cards exist the
    //     browser has long since attempted (and abandoned) its own restoration against
    //     a near-empty document. Park the offset and re-apply it once the restored
    //     pages have actually made the page tall enough to hold it.
    var SCROLL_KEY = 'cura:plp:scroll';
    var _restoreScrollY = null;

    function scrollStateKey() { return window.location.pathname + window.location.search; }

    function saveScrollPosition() {
      try {
        window.sessionStorage.setItem(SCROLL_KEY, JSON.stringify({
          key: scrollStateKey(),
          y: window.scrollY || window.pageYOffset || 0
        }));
      } catch (e) { /* private mode / quota — restoration is an enhancement */ }
    }
    // `pagehide` (not `beforeunload`) so this also fires when the page enters the
    // bfcache and on iOS Safari, where `beforeunload` is unreliable.
    window.addEventListener('pagehide', saveScrollPosition);

    (function readSavedScroll() {
      var isBackForward = false;
      try {
        var nav = window.performance.getEntriesByType && window.performance.getEntriesByType('navigation')[0];
        isBackForward = nav
          ? nav.type === 'back_forward'
          : !!(window.performance.navigation && window.performance.navigation.type === 2);
      } catch (e) { /* leave false: a normal load must start at the top */ }
      if (!isBackForward) {
        // A fresh visit to the same URL should NOT inherit an old offset.
        try { window.sessionStorage.removeItem(SCROLL_KEY); } catch (e) { }
        return;
      }
      try {
        var saved = JSON.parse(window.sessionStorage.getItem(SCROLL_KEY));
        // Same URL only — filters live in the query string, so a different search
        // means a different list and the saved offset is meaningless.
        if (saved && saved.key === scrollStateKey() && saved.y > 0) _restoreScrollY = saved.y;
      } catch (e) { }
      if (_restoreScrollY != null && 'scrollRestoration' in window.history) {
        // Stop the browser also nudging the page while we wait for the grid.
        window.history.scrollRestoration = 'manual';
      }
    })();

    function releaseScrollRestoration() {
      _restoreScrollY = null;
      if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'auto';
    }

    function tryRestoreScroll() {
      if (_restoreScrollY == null) return;
      // Scrolling before the document is tall enough clamps to the current bottom and
      // lands the reader in the wrong place, with no second chance.
      if (document.documentElement.scrollHeight < _restoreScrollY + window.innerHeight) return;
      var y = _restoreScrollY;
      releaseScrollRestoration();
      window.scrollTo(0, y);
    }

    if (_restoreScrollY != null) {
      search.on('render', function () {
        requestAnimationFrame(function () { requestAnimationFrame(tryRestoreScroll); });
      });
      // Card images resolve after render and change the document height, so retry on
      // load too — then give up, rather than hijacking a scroll the user has started.
      window.addEventListener('load', tryRestoreScroll);
      window.setTimeout(releaseScrollRestoration, 4000);
    }

    // ── Mobile drawer: stage selections, apply on "View results" ──────────────
    // The drawer's primary button is labelled "View results (N)", but every control
    // inside refined immediately, so the grid behind the drawer was already filtered
    // before it was tapped and the button did nothing but close. On mobile, selections
    // are now queued and committed as a batch when the shopper taps it. Desktop is
    // untouched: the rail has no apply button and is meant to filter live.
    //
    // Committing runs all queued refines in ONE tick, which InstantSearch coalesces
    // into a single search request rather than one per selection.
    var MOBILE_DRAWER = window.matchMedia('(max-width: 749px)');
    var _staged = [];
    var _catStagedPending = false;   // see applyCategoryRefinements()

    // Read the drawer state off the same body attribute the CSS and
    // assets/curaprox-collection-filters.js use, so this can never drift from it.
    function isStaging() {
      return MOBILE_DRAWER.matches && document.body.getAttribute('data-cura-filters') === 'open';
    }

    // Wrap any refinement so it defers while the mobile drawer is open.
    function staged(fn) {
      if (!isStaging()) { fn(); return; }
      _staged.push(fn);
    }

    function commitStaged() {
      if (!_staged.length) return;
      var ops = _staged;
      _staged = [];
      ops.forEach(function (fn) { fn(); });
    }

    // Dismissing the drawer without applying throws the queue away. The inputs still
    // show the shopper's un-committed ticks (nothing re-rendered them, because nothing
    // searched), so force a re-render to put the controls back in sync with real state.
    function discardStaged() {
      if (!_staged.length) return;
      _staged = [];
      _catStagedPending = false;
      search.refresh();
    }

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      // The apply button carries data-cura-filter-close too, so it must be tested first.
      if (e.target.closest('.cura-collection-filters__apply')) { commitStaged(); return; }
      if (e.target.closest('[data-cura-filter-close], .cura-collection-filters__backdrop')) discardStaged();
    }, true);

    // ── Staged preview: button count + live greying ───────────────────────────
    // On DESKTOP every tick fires a search, so InstantSearch recomputes facet
    // counts and withZeroCountValues() greys out the now-empty options. On MOBILE
    // refinements are STAGED — nothing searches until "View results" — so the
    // counts stay frozen and nothing greys while the shopper is still choosing.
    //
    // To match desktop without committing the refinement (which would re-filter
    // the grid behind the drawer), preview the pending selection against the
    // engine: one /multi-search per tick that returns (a) the total for the apply
    // button and (b) a facet distribution per group. Greying can't be read off
    // the on-screen numbers — two groups INTERSECT, they don't add — it needs a
    // real query. The mutations are transient: committing re-renders every group
    // from the real search, and discarding calls search.refresh(), so both paths
    // wipe the preview and no cleanup is needed here.
    var _previewSeq = 0;
    var _previewTimer = null;

    // Raw index values a rendered option stands for. A merged option's data-value
    // is a synthetic key (see MAPPED_PREFIX) encoding which valueMap entry it came
    // from; a plain option's data-value already IS the raw value.
    function rawsForDataValue(field, val) {
      val = String(val || '');
      if (val.indexOf(MAPPED_PREFIX) === 0) {
        var rest = val.slice(MAPPED_PREFIX.length);
        var cut = rest.lastIndexOf(':');
        var groups = mappedGroupsFor(rest.slice(0, cut));
        var entry = groups && groups[parseInt(rest.slice(cut + 1), 10)];
        if (entry && entry.values) return entry.values.slice();
      }
      return [val];
    }

    // The queued refinements, read off the DOM rather than from `_staged` — that
    // holds opaque closures, while the checked inputs already are the pending state.
    function stagedByField() {
      var byField = {};
      document.querySelectorAll('.cura-collection-filters [data-value]').forEach(function (input) {
        if (!input.checked || input.disabled) return;
        var group = input.closest('[id^="ms-facet-options-"]');
        if (!group) return;
        var field = group.id.replace('ms-facet-options-', '');
        byField[field] = (byField[field] || []).concat(rawsForDataValue(field, input.dataset.value));
      });
      return byField;
    }

    function baseFilterParts() {
      var parts = [];
      // `collectionId` (not config.collectionId): boot() may have resolved the
      // catch-all's ordering collection, and the staged count must match the grid.
      if (FILTER_BY_COLLECTION && collectionId) parts.push('collections.id = ' + collectionId);
      if (config.showOutOfStock === false) {
        parts.push('(totalInventory > 0 OR variants.inventoryPolicy = "CONTINUE")');
      }
      return parts;
    }

    function fieldClause(field, raws) {
      return '(' + raws.map(function (v) {
        return field + ' = "' + String(v).replace(/"/g, '\\"') + '"';
      }).join(' OR ') + ')';
    }

    // Filter for one facet group's OWN counts: base + every OTHER group's staged
    // selection, but NOT this group's — so its values keep the counts they would
    // have if picked (disjunctive OR faceting, exactly what InstantSearch does).
    // Passing exclude=null gives the full-intersection filter for the total count.
    function stagedFilter(byField, exclude) {
      var parts = baseFilterParts();
      Object.keys(byField).forEach(function (field) {
        if (field === exclude || !byField[field].length) return;
        parts.push(fieldClause(field, byField[field]));
      });
      return parts.join(' AND ');
    }

    // Apply a preview facet distribution (keyed by RAW value) to one rendered
    // group: sum raw counts into each option (merged options included), update the
    // count badge, and grey out anything that would return zero — never a checked
    // option, so it can always be un-picked.
    function applyPreviewCounts(field, dist) {
      var group = document.getElementById('ms-facet-options-' + field);
      if (!group) return;
      dist = dist || {};
      group.querySelectorAll('[data-value]').forEach(function (input) {
        var label = input.closest('label');
        if (!label) return;
        var n = rawsForDataValue(field, input.dataset.value).reduce(function (sum, raw) {
          return sum + (dist[raw] || 0);
        }, 0);
        var badge = label.querySelector('[data-filter-count]');
        if (badge) badge.textContent = n;
        var mod = ['cura-opt', 'cura-swatch', 'cura-chip-opt', 'cura-seg__item', 'cura-toggle']
          .filter(function (c) { return label.classList.contains(c); })[0];
        var off = n === 0 && !input.checked;
        input.disabled = off;
        if (mod) label.classList.toggle(mod + '--disabled', off);
      });
    }

    function runStagedPreview() {
      if (!isStaging() || !config.meilisearchHost) return;
      var byField = stagedByField();
      var fields = [];
      document.querySelectorAll('.cura-collection-filters [id^="ms-facet-options-"]').forEach(function (g) {
        fields.push(g.id.replace('ms-facet-options-', ''));
      });

      // One query for the button total (full intersection), then one per rendered
      // group for its disjunctive counts — bundled into a single /multi-search.
      var idx = config.meilisearchIndex;
      var queries = [{ indexUid: idx, q: '', limit: 0, filter: stagedFilter(byField, null) }];
      fields.forEach(function (f) {
        queries.push({ indexUid: idx, q: '', limit: 0, facets: [f], filter: stagedFilter(byField, f) });
      });

      var seq = ++_previewSeq;
      fetch(String(config.meilisearchHost).replace(/\/+$/, '') + '/multi-search', {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + config.meilisearchApiKey,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ queries: queries })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          // Ticks resolve out of order; only the newest may write to the DOM.
          if (seq !== _previewSeq || !d || !d.results) return;
          var total = d.results[0];
          if (total && typeof total.estimatedTotalHits === 'number') {
            document.querySelectorAll('.cura-collection-filters__apply [data-ms-count]')
              .forEach(function (el) { el.textContent = total.estimatedTotalHits; });
          }
          fields.forEach(function (f, i) {
            var res = d.results[i + 1];
            if (res) applyPreviewCounts(f, (res.facetDistribution || {})[f]);
          });
        })
        // Leave the last good numbers rather than blanking the rail.
        .catch(function () { });
    }

    document.addEventListener('change', function (e) {
      if (!isStaging() || !e.target || !e.target.closest) return;
      if (!e.target.closest('.cura-collection-filters')) return;
      // Debounce: a fast run of ticks collapses to one request.
      if (_previewTimer) clearTimeout(_previewTimer);
      _previewTimer = setTimeout(runStagedPreview, 140);
    });

    // ── Desktop rail height ───────────────────────────────────────────────────
    // The rail scrolls internally, but only fits on screen once it is pinned. At the
    // top of the page it starts below the hero and toolbar, so a fixed
    // `max-height: 100vh - 48px` runs off the bottom of the viewport and the last
    // filter groups cannot be reached without scrolling the PAGE first — which is
    // exactly what the internal scroll was meant to avoid.
    //
    // Size it to the space the rail can actually see instead: viewport height minus
    // wherever its top currently is. As the page scrolls and the rail rises to its
    // pinned position, the available space grows and the rail grows with it.
    var RAIL_GAP = 24;         // matches `top: 24px`
    var RAIL_MIN_HEIGHT = 240; // never collapse to a useless sliver on short screens
    var _railFrame = 0;

    function sizeFilterRail() {
      _railFrame = 0;
      var panel = document.querySelector('.cura-collection-filters__panel');
      if (!panel) return;
      // Mobile is a full-screen drawer with its own layout — leave it alone.
      if (MOBILE_DRAWER.matches) { panel.style.removeProperty('--cura-rail-max-h'); return; }
      // While the rail is closed it is laid out off-canvas, so its rect reports a
      // meaningless top (measuring then produced a full-viewport cap that stuck around
      // after opening). Only measure once it is actually on the page.
      if (document.body.getAttribute('data-cura-filters') !== 'open' || !panel.offsetParent) return;
      var top = panel.getBoundingClientRect().top;
      var available = window.innerHeight - Math.max(top, RAIL_GAP) - RAIL_GAP;
      panel.style.setProperty('--cura-rail-max-h', Math.max(RAIL_MIN_HEIGHT, available) + 'px');
    }

    function scheduleRailSize() {
      if (_railFrame) return;
      _railFrame = window.requestAnimationFrame(sizeFilterRail);
    }

    window.addEventListener('scroll', scheduleRailSize, { passive: true });
    window.addEventListener('resize', scheduleRailSize);
    // Every re-render that changes the rail's content height.
    search.on('render', scheduleRailSize);
    // Opening/closing the rail. The panel slides in, so re-measure after the
    // transition as well as immediately — the first pass runs mid-animation.
    new MutationObserver(function () {
      scheduleRailSize();
      window.setTimeout(sizeFilterRail, 400);
    }).observe(document.body, { attributes: true, attributeFilter: ['data-cura-filters'] });
    scheduleRailSize();

    // ── Softness "Why so soft?" tooltip ───────────────────────────────────────
    // On paper the <cura-collection-filters> custom element owns this toggle
    // (assets/curaprox-collection-filters.js). In practice the PLP — and the search
    // page — render a plain <div class="cura-collection-filters">, so the element
    // never upgrades and its click handler never binds: the ⓘ rendered and did
    // nothing. Drive it from here, where the group is actually built.
    // Place the (fixed-position) panel above its ⓘ and aim the tail at it. Fixed
    // positioning is what lets it overhang the rail — see the note in the stylesheet.
    var TIP_GAP = 8;          // breathing room between panel and heading
    var TIP_EDGE = 24;        // keep clear of the viewport edges

    function sizeSoftnessTip(toggle, tip) {
      var icon = toggle.getBoundingClientRect();
      var railEl = document.querySelector('.cura-collection-filters__panel');
      var rail = (railEl || document.body).getBoundingClientRect();
      var width = tip.offsetWidth;

      // Start flush with the rail, then pull back if that would run off-screen.
      var left = Math.min(rail.left, window.innerWidth - width - TIP_EDGE);
      left = Math.max(TIP_EDGE, left);

      // Above the icon by default; if there isn't room, sit below it and flip the tail.
      var height = tip.offsetHeight;
      var above = icon.top - TIP_GAP - height;
      var below = icon.bottom + TIP_GAP;
      var placeBelow = above < TIP_EDGE && below + height <= window.innerHeight - TIP_EDGE;

      tip.style.left = Math.round(left) + 'px';
      tip.style.top = Math.round(placeBelow ? below : Math.max(TIP_EDGE, above)) + 'px';
      tip.classList.toggle('cura-softness-tip--below', placeBelow);
      // Tail x is relative to the panel's own left edge.
      tip.style.setProperty('--cura-tip-tail-x',
        Math.round(icon.left + (icon.width / 2) - left) + 'px');
    }

    function closeSoftnessTips() {
      document.querySelectorAll('[data-cura-softness-tip]:not([hidden])').forEach(function (tip) {
        tip.setAttribute('hidden', '');
      });
      document.querySelectorAll('[data-cura-softness-toggle][aria-expanded="true"]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var toggle = e.target.closest('[data-cura-softness-toggle]');
      if (toggle) {
        e.preventDefault();
        var tip = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!tip) return;
        // The rail is a scroll container, and `position: fixed` does NOT escape an
        // ancestor's clipping when that ancestor establishes a containing block — the
        // panel was still being cut off at the rail's edge, losing half the copy.
        // Reparent it to <body> once; it is positioned from JS anyway, so it does not
        // need to sit next to its trigger.
        if (tip.parentElement !== document.body) document.body.appendChild(tip);
        var willOpen = tip.hasAttribute('hidden');
        closeSoftnessTips();
        if (willOpen) {
          tip.removeAttribute('hidden');
          toggle.setAttribute('aria-expanded', 'true');
          sizeSoftnessTip(toggle, tip);
        }
        return;
      }
      // A click anywhere else (except inside the panel itself) dismisses it.
      if (!e.target.closest('[data-cura-softness-tip]')) closeSoftnessTips();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSoftnessTips();
    });

    // Rotating to a width where the drawer no longer exists would otherwise strand the
    // queue with no button left to commit it.
    if (typeof MOBILE_DRAWER.addEventListener === 'function') {
      MOBILE_DRAWER.addEventListener('change', function (ev) { if (!ev.matches) commitStaged(); });
    }

    var configureOptions = { hitsPerPage: productsPerPage };
    if (baseFilters.length) configureOptions.filters = baseFilters.join(' AND ');
    widgets.push(window.instantsearch.widgets.configure(configureOptions));

    // Facets: one refinement list per metafield filter. Collapsible (Figma-only
    // requirement, spec doc silent on default — first group open + any group with
    // an active filter open, applied once; never re-forced after a manual toggle).
    // Collapse state lives on the persistent groupEl/listEl DOM nodes themselves
    // (only their innerHTML/attrs are touched on re-render, never recreated), so
    // it survives every Meili re-render with no separate state object needed.
    // ── Price range group ─────────────────────────────────────────────────────
    // Two overlapping <input type="range"> handles over a shared track. This is
    // the accessible dual-slider pattern: each handle is a real focusable range
    // input, so keyboard and screen-reader support come for free, and the visual
    // track/fill is decoration underneath. The number inputs are the precise
    // entry path, and the buckets are the one-tap shortcuts the spec asks for.
    //
    // The DOM is created ONCE and only its values/attributes are updated on each
    // Meili render. Re-rendering innerHTML here would drop the handle mid-drag
    // and steal focus from the number inputs while typing.
    function wirePriceRangeGroup(filter, field, groupEl, listEl, setGroupOpen, isAutoOpenApplied, markAutoOpenApplied) {
      var buckets = priceBuckets(filter);
      var refineRange = null;
      var bounds = { min: 0, max: 0 };   // full range available in this collection
      var current = { min: null, max: null };
      var built = false;
      var els = {};

      function clampInt(n, lo, hi) {
        n = Math.round(Number(n));
        if (!isFinite(n)) return lo;
        return Math.min(hi, Math.max(lo, n));
      }

      // connectRange wants `undefined` for "no bound", not the track extremes —
      // passing the extremes would write a redundant refinement into the URL and
      // light up an applied chip for a filter the shopper never set.
      function applyRange(lo, hi) {
        if (!refineRange) return;
        _scrollPending = true;
        refineRange([
          lo != null && lo > bounds.min ? lo : undefined,
          hi != null && hi < bounds.max ? hi : undefined
        ]);
      }

      function build() {
        listEl.innerHTML =
          '<div class="cura-price">' +
          '<div class="cura-price__buckets" role="group">' +
          buckets.map(function (b, i) {
            return '<button type="button" class="cura-price__bucket" data-price-bucket="' + i + '">' +
              priceBucketLabelHtml(b) + '</button>';
          }).join('') +
          '</div>' +
          '<div class="cura-price__slider">' +
          '<div class="cura-price__track" aria-hidden="true"><div class="cura-price__fill" data-price-fill></div></div>' +
          '<input type="range" class="cura-price__handle cura-price__handle--min" data-price-handle="min" aria-label="' + escapeHtml(priceCfg.minLabel || 'Minimum') + '">' +
          '<input type="range" class="cura-price__handle cura-price__handle--max" data-price-handle="max" aria-label="' + escapeHtml(priceCfg.maxLabel || 'Maximum') + '">' +
          '</div>' +
          '<div class="cura-price__inputs">' +
          '<label class="cura-price__field"><span class="visually-hidden">' + escapeHtml(priceCfg.minLabel || 'Minimum') + '</span>' +
          '<input type="number" inputmode="numeric" class="cura-price__num" data-price-num="min"></label>' +
          '<span class="cura-price__dash" aria-hidden="true">–</span>' +
          '<label class="cura-price__field"><span class="visually-hidden">' + escapeHtml(priceCfg.maxLabel || 'Maximum') + '</span>' +
          '<input type="number" inputmode="numeric" class="cura-price__num" data-price-num="max"></label>' +
          '</div>' +
          '</div>';

        els.fill = listEl.querySelector('[data-price-fill]');
        els.hMin = listEl.querySelector('[data-price-handle="min"]');
        els.hMax = listEl.querySelector('[data-price-handle="max"]');
        els.nMin = listEl.querySelector('[data-price-num="min"]');
        els.nMax = listEl.querySelector('[data-price-num="max"]');

        // Handles: live paint while dragging, commit on release. Committing on
        // every input event would fire a Meili query per pixel of drag.
        [els.hMin, els.hMax].forEach(function (h) {
          h.addEventListener('input', function () {
            var lo = Number(els.hMin.value);
            var hi = Number(els.hMax.value);
            // Stop the handles crossing over each other.
            if (h === els.hMin && lo > hi) { lo = hi; els.hMin.value = String(lo); }
            if (h === els.hMax && hi < lo) { hi = lo; els.hMax.value = String(hi); }
            current.min = lo; current.max = hi;
            paint();
          });
          h.addEventListener('change', function () {
            applyRange(Number(els.hMin.value), Number(els.hMax.value));
          });
        });

        // Number inputs commit on blur/Enter, not per keystroke — otherwise typing
        // "25" fires a query for "2" first and yanks the grid out from under you.
        [els.nMin, els.nMax].forEach(function (n) {
          n.addEventListener('change', commitNumbers);
          n.addEventListener('keydown', function (e) { if (e.key === 'Enter') commitNumbers(); });
        });

        listEl.querySelectorAll('[data-price-bucket]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var b = buckets[Number(btn.dataset.priceBucket)];
            if (!b) return;
            // Re-clicking the active bucket clears it, so a bucket is never a dead end.
            if (btn.classList.contains('is-active')) { applyRange(undefined, undefined); return; }
            applyRange(b.min != null ? b.min : bounds.min, b.max != null ? b.max : bounds.max);
          });
        });
        built = true;
      }

      function commitNumbers() {
        var lo = els.nMin.value === '' ? bounds.min : clampInt(els.nMin.value, bounds.min, bounds.max);
        var hi = els.nMax.value === '' ? bounds.max : clampInt(els.nMax.value, bounds.min, bounds.max);
        if (lo > hi) { var t = lo; lo = hi; hi = t; }
        applyRange(lo, hi);
      }

      function paint() {
        var span = bounds.max - bounds.min;
        var lo = current.min != null ? current.min : bounds.min;
        var hi = current.max != null ? current.max : bounds.max;
        var a = span > 0 ? ((lo - bounds.min) / span) * 100 : 0;
        var b = span > 0 ? ((hi - bounds.min) / span) * 100 : 100;
        if (els.fill) { els.fill.style.insetInlineStart = a + '%'; els.fill.style.width = Math.max(0, b - a) + '%'; }
        if (els.nMin) els.nMin.value = String(lo);
        if (els.nMax) els.nMax.value = String(hi);

        // A bucket is "active" only when the committed range matches it exactly,
        // so dragging the slider near a bucket does not falsely light it up.
        listEl.querySelectorAll('[data-price-bucket]').forEach(function (btn) {
          var bk = buckets[Number(btn.dataset.priceBucket)];
          var bLo = bk.min != null ? bk.min : bounds.min;
          var bHi = bk.max != null ? bk.max : bounds.max;
          btn.classList.toggle('is-active', lo === bLo && hi === bHi);
        });
      }

      var connectR = window.instantsearch.connectors.connectRange(function (state, isFirst) {
        refineRange = state.refine;
        var r = state.range || {};
        var s = state.start || [];

        // Meili reports the true bounds for the current result set. Guard against
        // the degenerate all-same-price case, where min === max would make the
        // track zero-width and the handles unusable.
        bounds.min = Math.floor(r.min != null ? r.min : 0);
        bounds.max = Math.ceil(r.max != null ? r.max : 0);
        if (bounds.max <= bounds.min) bounds.max = bounds.min + 1;

        // The whole group is pointless when the collection has no price spread.
        groupEl.hidden = !(r.max > r.min);
        if (groupEl.hidden) return;

        if (!built) build();

        current.min = (s[0] != null && isFinite(s[0])) ? Math.floor(s[0]) : bounds.min;
        current.max = (s[1] != null && isFinite(s[1])) ? Math.ceil(s[1]) : bounds.max;

        [els.hMin, els.hMax].forEach(function (h) {
          h.min = String(bounds.min);
          h.max = String(bounds.max);
          h.step = '1';
        });
        [els.nMin, els.nMax].forEach(function (n) {
          n.min = String(bounds.min);
          n.max = String(bounds.max);
        });
        els.hMin.value = String(current.min);
        els.hMax.value = String(current.max);
        paint();

        if (!isFirst && !isAutoOpenApplied()) {
          markAutoOpenApplied();
          if (current.min > bounds.min || current.max < bounds.max) setGroupOpen(true);
        }
      });

      widgets.push(connectR({ attribute: field, precision: 0 }));
    }

    var facetsRoot = document.querySelector('[data-ms-facets]');
    sortedFilters.forEach(function (filter, filterIdx) {
      var field = filter.meilisearchField;
      var groupEl = document.getElementById('ms-facet-' + field);
      var defaultOpen = filterIdx === 0;
      // Build the group shell if the section didn't pre-render it
      if (!groupEl && facetsRoot) {
        groupEl = document.createElement('div');
        // The --softness modifier is what the stylesheet anchors the "Why so soft?"
        // info tooltip to (it needs a positioned group head), so it has to be on the
        // group itself, not the option list.
        groupEl.className = 'cura-fgroup' +
          (isSoftnessGroup(filter) ? ' cura-fgroup--softness' : '');
        groupEl.id = 'ms-facet-' + field;
        groupEl.setAttribute('data-filter-group', field);
        groupEl.hidden = true;
        groupEl.innerHTML =
          '<div class="cura-fgroup__head">' +
          '<button type="button" class="cura-fgroup__toggle" data-cura-fgroup-toggle' +
          ' aria-expanded="' + defaultOpen + '" aria-controls="ms-facet-options-' + field + '">' +
          '<h3 class="cura-fgroup__title s3 bold">' + escapeHtml(getFilterLabel(filter)) + '</h3>' +
          '<span class="cura-fgroup__chevron" aria-hidden="true">' + (config.caretIcon || '') + '</span>' +
          '</button>' +
          buildSoftnessTipHtml(filter) +
          '</div>' +
          '<div class="cura-fgroup__body" id="ms-facet-options-' + field + '"' + (defaultOpen ? '' : ' hidden') + '></div>';
        facetsRoot.appendChild(groupEl);
      }
      var listEl = document.getElementById('ms-facet-options-' + field);
      if (!groupEl || !listEl) return;

      var toggleBtn = groupEl.querySelector('[data-cura-fgroup-toggle]');
      var autoOpenApplied = false;
      function setGroupOpen(open) {
        listEl.hidden = !open;
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', String(open));
      }
      if (toggleBtn) {
        toggleBtn.addEventListener('click', function () {
          autoOpenApplied = true; // user took control; stop auto-opening this group
          setGroupOpen(listEl.hidden);
        });
      }

      // Price uses connectRange, not connectRefinementList — different state shape
      // (start/range tuples instead of a value list), different markup, and the DOM
      // is built once then mutated rather than re-rendered, so dragging a handle
      // isn't interrupted by a re-render mid-gesture.
      if (isRangeFilter(filter)) {
        wirePriceRangeGroup(filter, field, groupEl, listEl, setGroupOpen, function () {
          return autoOpenApplied;
        }, function () { autoOpenApplied = true; });
        return;
      }

      var refine = null;
      var currentItems = [];   // last rendered facet values — single-select needs the refined one
      listEl.addEventListener('change', function (e) {
        if (!refine) return;
        if (e.target.type !== 'checkbox' && e.target.type !== 'radio') return;
        _scrollPending = true;
        // Single-select (radio/segmented): drop the previously refined value first,
        // otherwise refinementList ORs the two together and the group behaves like a
        // checkbox list wearing radio chrome. The DOM already shows only the new one
        // as checked, so without this the UI and the query would disagree.
        // Captured now: by the time a staged batch runs, `currentItems` and the event
        // target may both have moved on.
        var clicked = e.target.dataset.value;
        var previouslyRefined = isSingleSelectMode(filter.displayMode)
          ? currentItems.filter(function (item) { return item.isRefined && item.value !== clicked; })
            .map(function (item) { return item.value; })
          : [];
        staged(function () {
          // Drop the previously refined value so the group is one-of-N.
          previouslyRefined.forEach(function (value) { refineMapped(value); });
          refineMapped(clicked);
        });
      });

      // Re-clicking the ACTIVE radio clears it — without this a single-select group
      // is a dead end (no "all" row is rendered, so clear-all would be the only way
      // back to unfiltered). It has to hang off 'click', not 'change': re-clicking a
      // checked radio changes nothing, so the browser fires no change event at all.
      // Verified by harness: the change-only version left the value stuck refined.
      // Guarded to e.target being the input itself — a click on the wrapping <label>
      // bubbles once as the label and again as the synthetic input click.
      listEl.addEventListener('click', function (e) {
        if (!refine || !isSingleSelectMode(filter.displayMode)) return;
        var input = e.target;
        if (input.tagName !== 'INPUT' || input.type !== 'radio') return;
        var value = input.dataset.value;
        var isActive = currentItems.some(function (item) {
          return item.isRefined && item.value === value;
        });
        if (!isActive) return;
        _scrollPending = true;
        input.checked = false;
        staged(function () { refineMapped(value); });
      });

      // Every facet value this group has EVER offered, in first-seen order.
      // Meilisearch's facet distribution omits zero-count values, so once a
      // refinement narrows the result set the non-matching options vanish from
      // `state.items` entirely. Dropping them out of the DOM creates the dead
      // ends the spec calls out (Miro item 11): the shopper cannot see that the
      // option exists, nor that it is empty *because of* their current
      // selection. Remembering the union and re-injecting the missing values at
      // count 0 lets them render greyed-out and inert instead.
      var knownValues = [];        // [{ value, label }] — insertion-ordered
      var knownIndex = {};         // value -> position in knownValues

      function mergeKnownValues(items) {
        items.forEach(function (item) {
          if (Object.prototype.hasOwnProperty.call(knownIndex, item.value)) {
            // Labels can arrive translated/re-cased on later renders; keep the freshest.
            knownValues[knownIndex[item.value]].label = item.label;
            return;
          }
          knownIndex[item.value] = knownValues.length;
          knownValues.push({ value: item.value, label: item.label, rawValues: item.rawValues });
        });
      }

      // Which RAW values are refined right now, straight from the engine. A
      // merged option needs this to know whether a click is switching it on or
      // off — its own `isRefined` is an OR across members and cannot say which.
      var lastRawRefined = {};

      function rawValuesFor(value) {
        for (var i = 0; i < currentItems.length; i++) {
          if (currentItems[i].value === value) return currentItems[i].rawValues || [value];
        }
        return [value];
      }

      // A merged option is several raw refinements wearing one row, so toggling
      // it means toggling every value it stands for. Turning it OFF must clear
      // only the members actually refined — refine() is a toggle, so passing the
      // whole set would switch the untouched ones ON instead.
      function refineMapped(value) {
        var raws = rawValuesFor(value);
        if (raws.length === 1) { refine(raws[0]); return; }
        var on = raws.filter(function (raw) { return lastRawRefined[raw]; });
        (on.length ? on : raws).forEach(function (raw) { refine(raw); });
      }

      // Live values first (engine order — `sortBy: ['name:asc']`), then any
      // remembered value the engine no longer returns, appended as count 0.
      // Refined values are never disabled: un-picking one must always be
      // possible, and single-select modes rely on clicking the active row.
      function withZeroCountValues(items) {
        var seen = {};
        var out = items.map(function (item) {
          seen[item.value] = true;
          return item;
        });
        knownValues.forEach(function (known) {
          if (seen[known.value]) return;
          out.push({
            value: known.value,
            label: known.label,
            rawValues: known.rawValues,
            count: 0,
            isRefined: false,
            disabled: true
          });
        });
        return out;
      }

      var connect = window.instantsearch.connectors.connectRefinementList(function (state, isFirst) {
        refine = state.refine;

        // Everything below the mapping works in DISPLAY values: `currentItems`
        // feeds the single-select logic and the zero-count memory, both of which
        // must agree with the `data-value` in the DOM. Only refineMapped() ever
        // translates back to raw values.
        lastRawRefined = {};
        state.items.forEach(function (it) {
          if (it.isRefined) lastRawRefined[it.value] = true;
        });

        currentItems = mapFacetItems(field, state.items);
        mergeKnownValues(currentItems);
        if (isFirst) return;

        var renderItems = withZeroCountValues(currentItems);

        // The softness group is a SCALE, so it has to read as one: softest to firmest,
        // top to bottom (Figma 1581:29455 shows a clean 1→2→3→4 ladder). Meilisearch
        // returns facet values in count/alphabetical order, which had the meter going
        // 3, 2, 3, 4, 1 down the list — the ladder was there but scrambled, which is
        // worse than no meter. Unmapped values (level 0) sink to the bottom, keeping
        // their relative order, rather than pretending to be the softest.
        if (isSoftnessGroup(filter)) {
          renderItems = renderItems.slice().sort(function (a, b) {
            var la = softnessLevel(filter, softnessKey(a));
            var lb = softnessLevel(filter, softnessKey(b));
            if (la === lb) return 0;
            if (!la) return 1;
            if (!lb) return -1;
            return la - lb;
          });
        }

        // Only a group that has never had a single value stays hidden — that is a
        // filter which does not apply to this collection at all, as opposed to one
        // the current refinement has emptied.
        groupEl.hidden = renderItems.length === 0;
        if (renderItems.length === 0) { listEl.innerHTML = ''; return; }

        listEl.innerHTML = filter.displayMode === 'toggle'
          ? buildToggleGroupHtml(filter, field, state.items)
          : renderItems.map(function (item) { return buildFacetOptionHtml(filter, field, item); }).join('');
        listEl.classList.toggle('cura-colors', filter.displayMode === 'swatch');
        listEl.classList.toggle('cura-chips', filter.displayMode === 'chips');
        listEl.classList.toggle('cura-seg', filter.displayMode === 'segmented');

        // Auto-open once if this group has an active refinement (e.g. deep-linked
        // via the URL) — only on the first real render, never overriding a later
        // manual toggle.
        if (!autoOpenApplied) {
          autoOpenApplied = true;
          if (state.items.some(function (it) { return it.isRefined; })) setGroupOpen(true);
        }
      });

      widgets.push(connect({ attribute: facetAttrFor(filter), operator: 'or', limit: 100, sortBy: ['name:asc'] }));
    });

    // Hierarchical category filter wired to the collection-hero tabs
    var catNav = document.querySelector('[data-ms-category-nav]');
    var _catPath = parseCategoryFromUrl(); // clicked nodes (restored from the URL); only the last may be a leaf
    var _catCounts = {};     // catKey -> result count from the facet distribution
    var _catRefine = null;   // refinementList refine fn
    var _catRefinedNow = []; // catKeys currently refined (from facet state)
    var _catVisibleNodes = []; // the exact node objects currently rendered as tabs

    function catRefinedKeys() {
      if (!_catPath.length) return [];
      if (CATEGORY_MODE === 'replace') return [catKey(_catPath[_catPath.length - 1])];
      return _catPath.map(catKey);
    }
    // A node is an "effective leaf" once no sub-category has results - apply + highlight it in place
    function nodeHasVisibleChildren(node) {
      return !!node && !!node.children && catVisibleNodes(node.children).length > 0;
    }
    function catLevelNodes() {
      if (!_catPath.length) return categoryMenu;
      var last = _catPath[_catPath.length - 1];
      if (nodeHasVisibleChildren(last)) return last.children;
      if (_catPath.length >= 2) return _catPath[_catPath.length - 2].children || [];
      return categoryMenu;
    }
    function catHighlight() {
      if (!_catPath.length) return null;
      var last = _catPath[_catPath.length - 1];
      return nodeHasVisibleChildren(last) ? null : catKey(last);
    }
    // Category node label. The tree carries BOTH the linked collection's title
    // (`name`) and the navigation menu item's title (`title`). Only `name` is
    // locale-aware — Shopify translates collection titles, but the menu item
    // titles in this store are German in every locale, so rendering `title` put
    // "Handzahnbürste" in the tabs on /en/ next to an H1 reading "Manual
    // Toothbrushes". Prefer `name`, fall back to `title` for nodes that have no
    // linked collection (e.g. a CATALOG or placeholder link).
    // The parent-category prefix is stripped off the same way the Liquid tabs do
    // it, so the client-rendered fallback nav reads identically ("Zahnbürste
    // Manual Toothbrushes" → "Manual Toothbrushes").
    function catLabel(n) {
      if (!n) return '';
      var name = n.name ? n.name : (n.title ? n.title : '');
      var parent = _catByKey[_catParentKey[catKey(n)]];
      return stripParentPrefix(name, parent ? (parent.name || parent.title) : '');
    }

    function categoryChipsHtml() {
      var nodes = (CATEGORY_MODE === 'replace' && _catPath.length) ? [_catPath[_catPath.length - 1]] : _catPath;
      return nodes.map(function (n) {
        return '<button type="button" class="cura-chip" data-ms-cat-chip="' + escapeHtml(catKey(n)) + '" aria-label="Remove filter: ' + escapeHtml(catLabel(n)) + '">' +
          '<span class="cura-chip__text">' + escapeHtml(catLabel(n)) + '</span>' +
          '<span class="cura-chip__x" aria-hidden="true">' + CHIP_X + '</span>' +
          '</button>';
      }).join('');
    }
    // Visible nodes for a level: a node with results is shown; a node with no
    // results but matching descendants is replaced by those descendants (surfaced
    // up a level), so an empty parent never hides its matching sub-categories.
    function catVisibleNodes(nodes) {
      var out = [];
      (nodes || []).forEach(function (n) {
        if ((_catCounts[catKey(n)] || 0) > 0) out.push(n);
        else if (n.children && n.children.length) catVisibleNodes(n.children).forEach(function (d) { out.push(d); });
      });
      return out;
    }
    function renderCategoryNav() {
      if (!catNav) return;
      var hl = catHighlight();
      _catVisibleNodes = catVisibleNodes(catLevelNodes());
      catNav.innerHTML = _catVisibleNodes.map(function (n) {
        var key = catKey(n);
        var active = key === hl;
        return '<button type="button" class="collection-hero__tab' + (active ? ' collection-hero__tab--active' : '') + '"' +
          ' data-ms-cat="' + escapeHtml(key) + '"' + (active ? ' aria-current="true"' : '') + '>' + escapeHtml(catLabel(n)) + '</button>';
      }).join('');
    }
    // Toggle the facet refinements to match catRefinedKeys()
    function applyCategoryRefinements() {
      if (!_catRefine) return;
      function reconcile() {
        _catStagedPending = false;
        var want = catRefinedKeys();
        _catRefinedNow.forEach(function (k) { if (want.indexOf(k) === -1) _catRefine(k); });
        want.forEach(function (k) { if (_catRefinedNow.indexOf(k) === -1) _catRefine(k); });
      }
      if (!isStaging()) { reconcile(); return; }
      // Exactly ONE reconcile may be queued. It diffs against `_catRefinedNow`, which is
      // only refreshed by a render — and staging means no render happens — so a second
      // queued copy would diff against the same stale baseline and undo the first.
      // Queuing once is sufficient: it reads _catPath when it runs, so it always sees
      // the shopper's final drill-down.
      if (_catStagedPending) return;
      _catStagedPending = true;
      _staged.push(reconcile);
    }
    function selectCategory(node) {
      if (!node) return;
      _scrollPending = true;
      var last = _catPath.length ? _catPath[_catPath.length - 1] : null;
      // Clicking a sibling at a leaf level replaces the current leaf selection
      if (last && !nodeHasVisibleChildren(last)) _catPath.pop();
      _catPath.push(node);
      applyCategoryRefinements();
      renderCategoryNav();
    }
    function removeCategory(key) {
      var idx = -1;
      for (var i = 0; i < _catPath.length; i++) { if (catKey(_catPath[i]) === key) { idx = i; break; } }
      if (idx === -1) return;
      _scrollPending = true;
      _catPath = _catPath.slice(0, idx); // drop this node and anything deeper
      applyCategoryRefinements();
      renderCategoryNav();
    }

    if (catNav && categoryMenu.length) {
      var connectCat = window.instantsearch.connectors.connectRefinementList(function (state) {
        _catRefine = state.refine;
        _catRefinedNow = state.items.filter(function (it) { return it.isRefined; }).map(function (it) { return it.value; });
        _catCounts = {};
        state.items.forEach(function (it) { _catCounts[it.value] = it.count; });
        renderCategoryNav();
      });
      widgets.push(connectCat({ attribute: CATEGORY_FIELD, operator: 'and', limit: 1000 }));

      catNav.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-ms-cat]');
        if (!btn) return;
        var key = btn.getAttribute('data-ms-cat');
        // Toggle: clicking the already-active tab removes it (drills back up a level → "show all")
        if (key === catHighlight()) { removeCategory(key); return; }
        // Use the displayed node (right children in context), not a global id lookup that can collide
        var node = null;
        for (var i = 0; i < _catVisibleNodes.length; i++) {
          if (catKey(_catVisibleNodes[i]) === key) { node = _catVisibleNodes[i]; break; }
        }
        selectCategory(node || _catByKey[key]);
      });
    }

    // Applied-filter chips
    var _refinementsState = null;
    var chipsEl = document.querySelector('[data-cura-applied-chips]');
    var appliedGroup = document.querySelector('.cura-applied');

    // Mobile active-filter count badge (collection-toolbar.liquid [data-ms-filter-count]).
    // Also feeds the no-results-with-filters hint below (facet OR category active).
    var _hasActiveRefinements = false;
    function updateFilterCountBadge(count) {
      document.querySelectorAll('[data-ms-filter-count]').forEach(function (el) {
        el.textContent = String(count);
        el.hidden = count === 0;
      });
    }

    // Chip for a picked sort — otherwise it is a one-way door, since a radio group has
    // no "none" state. Label comes off the radio's <span>, so it stays translated.
    function sortChipHtml() {
      if (_sortRadio === null) return '';
      var el = null;
      sortEls.forEach(function (candidate) { if (candidate.value === _sortRadio) el = candidate; });
      if (!el) return '';
      var wrap = el.closest('.cura-opt');
      var labelEl = wrap ? wrap.querySelector('.cura-opt__label') : null;
      var label = labelEl ? labelEl.textContent.trim() : _sortRadio;
      return (
        '<button type="button" class="cura-chip" data-ms-sort-chip aria-label="Remove sort: ' + escapeHtml(label) + '">' +
        '<span class="cura-chip__text">' + escapeHtml(label) + '</span>' +
        '<span class="cura-chip__x" aria-hidden="true">' + CHIP_X + '</span>' +
        '</button>'
      );
    }

    var connectCR = window.instantsearch.connectors.connectCurrentRefinements(function (state) {
      _refinementsState = state;
      var items = state.items || [];
      var refs = [];
      items.forEach(function (item) {
        if (item.attribute === CATEGORY_FIELD) return; // category chips are rendered separately
        item.refinements.forEach(function (r) { refs.push({ item: item, r: r }); });
      });

      // One chip per DISPLAY value, not per raw refinement. A merged option like
      // "Ohne Fluorid" stands for three raw values ("false" / "No" / "Without
      // fluoride"); picking it refines all three, which would otherwise render as
      // three identical chips that each only clear a third of the selection.
      // Collapsed here, and the raw values ride along so removal clears them all.
      var byLabel = {};
      refs = refs.filter(function (entry) {
        entry.label = displayValueLabel(entry.item.attribute, String(entry.r.value));
        var key = entry.item.attribute + SEP + entry.label;
        if (byLabel[key]) {
          byLabel[key].values.push(String(entry.r.value));
          return false;
        }
        byLabel[key] = entry;
        entry.values = [String(entry.r.value)];
        return true;
      });

      // Badge counts facet values only (category tabs are a separate mechanism,
      // same scope as what feeds these chips); the hint below also considers category.
      updateFilterCountBadge(refs.length);
      _hasActiveRefinements = refs.length > 0 || (_catPath && _catPath.length > 0);

      if (!chipsEl) return;

      var metaHtml = refs.map(function (entry) {
        return (
          '<button type="button" class="cura-chip" data-ms-chip data-attr="' + escapeHtml(entry.item.attribute) + '" data-val="' + escapeHtml(entry.values.join(SEP)) + '" aria-label="Remove filter: ' + escapeHtml(entry.label) + '">' +
          '<span class="cura-chip__text">' + escapeHtml(entry.label) + '</span>' +
          '<span class="cura-chip__x" aria-hidden="true">' + CHIP_X + '</span>' +
          '</button>'
        );
      }).join('');

      var catHtml = categoryChipsHtml();
      var sortHtml = sortChipHtml();

      if (!metaHtml && !catHtml && !sortHtml) {
        chipsEl.innerHTML = '';
        if (appliedGroup) appliedGroup.hidden = true;
        return;
      }
      if (appliedGroup) appliedGroup.hidden = false;
      chipsEl.innerHTML = catHtml + metaHtml + sortHtml;
    });
    widgets.push(connectCR({}));

    // Sort: drive the sidebar radio group
    var sortEls = Array.prototype.slice.call(document.querySelectorAll('input[name="cura-sort"]'));
    function sortValueFor(radioValue) {
      switch (radioValue) {
        case 'price-ascending': return INDEX + ':' + PRICE_FIELD + ':asc';
        case 'price-descending': return INDEX + ':' + PRICE_FIELD + ':desc';
        case 'created-descending': return INDEX + ':' + CREATED_FIELD + ':desc';
        case 'relevance': return INDEX;
        default: return DEFAULT_SORT; // no radio picked → the collection's admin order
      }
    }
    // Default first, so connectSortBy falls back to it. Relevance is a real option now,
    // and on /collections/all it collapses onto the same value — hence the dedupe.
    var sortItems = [{ label: 'collection-order', value: DEFAULT_SORT }];
    sortEls.forEach(function (el) {
      var value = sortValueFor(el.value);
      var exists = sortItems.some(function (it) { return it.value === value; });
      if (el.value && !exists) sortItems.push({ label: el.value, value: value });
    });

    var connectSort = window.instantsearch.connectors.connectSortBy(function (state, isFirst) {
      if (isFirst) {
        sortEls.forEach(function (el) {
          // Sort lives in the same mobile drawer ("Filter & Sort"), so it defers with
          // everything else — otherwise tapping a sort option would re-order the grid
          // behind the drawer before "View results" was pressed.
          el.addEventListener('change', function () {
            if (!el.checked) return;
            _scrollPending = true;
            var value = el.value;
            // _sortRadio is set INSIDE the staged callback: dismissing the drawer drops
            // the queue, and an eager write would leave a chip for an unapplied sort.
            staged(function () {
              _sortRadio = value;
              state.refine(sortValueFor(value));
            });
          });
        });
        // Back to the admin order (clear-all, or a Back nav onto a URL with no ?sort)
        _resetSort = function () {
          if (_sortRadio === null) return;
          // On /collections/all "Relevance" IS the default, so refine() would be a no-op
          // and nothing would re-render — the chip would survive its own removal.
          var sameRanking = sortValueFor(_sortRadio) === DEFAULT_SORT;
          _sortRadio = null;
          if (sameRanking) search.refresh();
          else state.refine(DEFAULT_SORT);
        };
      }
      sortEls.forEach(function (el) {
        el.checked = _sortRadio !== null && el.value === _sortRadio;
      });
    });
    widgets.push(connectSort({ items: sortItems }));

    // Hits overlay the native grid (built client-side via ensureGrid() when the
    // Shopify collection is server-side empty — see its definition above)
    var hitsEl = ensureGrid();
    var gridParent = hitsEl ? hitsEl.parentElement : null;

    // Snapshot of the cards main-collection.liquid already rendered. Everything
    // below replaces them with Meili results, so when the backend is unreachable
    // or its index is missing we would otherwise destroy a perfectly good grid and
    // leave the shopper on an empty page. meilisearch-search.js already keeps
    // native results when a search fails; this is the same policy for the PLP.
    // Skeletons are excluded — they are our own placeholders, not server output.
    // Only <li> cards count: product-grid.liquid also puts an inline <script>
    // (grid-view restore) inside the <ul>, and since main-collection.liquid
    // renders the <ul> for Meili stores even when the Shopify collection is
    // empty (skeletons reserve the grid height at first paint), a script-only
    // fallback would otherwise look like "server rendered products".
    var _fallbackHtml = '';
    if (hitsEl) {
      _fallbackHtml = Array.prototype.filter
        .call(hitsEl.children, function (el) {
          return el.nodeType === 1 && el.tagName === 'LI' && !el.classList.contains('ms-skeleton-item');
        })
        .map(function (el) { return el.outerHTML; })
        .join('');
    }
    var _degraded = false;
    var _renderedHits = false;

    // One-way switch: hand the grid back to Liquid and stop touching it. Callers
    // pass the reason so the console says which failure triggered it.
    function degradeToServerGrid(reason) {
      if (_degraded || !hitsEl || !_fallbackHtml) return;
      _degraded = true;
      console.error('[ms-collection] ' + reason + '. Restoring server-rendered grid.');
      // .ms-grid-pending hides Liquid cards; they are all the shopper gets now
      document.documentElement.classList.remove('ms-grid-pending');
      hitsEl.innerHTML = _fallbackHtml;
      if (sentinel) sentinel.hidden = true;
      if (loadMoreWrap) loadMoreWrap.hidden = true;
    }

    // Remove Horizon's native infinite-scroll sentinels so paginated-list.js doesn't
    // fetch server pages into the Meili-driven grid
    var nativeList = hitsEl && hitsEl.closest('results-list');
    if (nativeList) {
      nativeList.querySelectorAll('[ref="viewMoreNext"], [ref="viewMorePrevious"], .product-grid__load-more').forEach(function (el) { el.remove(); });
    }

    var loadMode = config.loadMode === 'button' ? 'button' : 'auto';
    var sentinel = null;
    var loadMoreBtn = null;
    var loadMoreWrap = null;
    if (gridParent) {
      if (loadMode === 'button') {
        // Manual "Load more" button (Figma 1653:55522) — secondary CTA pill,
        // hidden on the last page. Click loads the next Meili page (loadNext is
        // hoisted from below). Replaces the auto-scroll sentinel.
        loadMoreWrap = document.createElement('div');
        loadMoreWrap.className = 'ms-load-more-wrap';
        loadMoreBtn = document.createElement('button');
        loadMoreBtn.type = 'button';
        loadMoreBtn.className = 'cta cta--button-secondary ms-load-more';
        loadMoreBtn.textContent = config.loadMoreText || 'Load more';
        // Toggle the WRAPPER (a plain div), not the .cta button: .cta sets
        // display:inline-flex which would override the [hidden] attribute and
        // leave the button visible. Start hidden so it never flashes before the
        // first results render.
        loadMoreWrap.hidden = true;
        loadMoreBtn.addEventListener('click', function () { loadNext(); });
        loadMoreWrap.appendChild(loadMoreBtn);
        gridParent.appendChild(loadMoreWrap);
      } else {
        // Sentinel auto-loads the next page near the viewport, hidden on the last page
        sentinel = document.createElement('div');
        sentinel.className = 'ms-sentinel';
        sentinel.hidden = true;
        gridParent.appendChild(sentinel);
      }
    }

    function buildLi(hit) {
      var li = document.createElement('li');
      li.className = 'product-grid__item';
      li.setAttribute('data-handle', getHandle(hit));
      li.setAttribute('data-product-id', String(hit.id == null ? '' : hit.id));
      var card = document.createElement('product-card');
      card.className = 'product-card size-style';
      card.setAttribute('data-product-id', String(hit.id == null ? '' : hit.id));
      card.innerHTML = buildCardInner(hit);
      li.appendChild(card);
      return li;
    }

    // Render in Meili order: append-only when results extend what's shown (infinite
    // scroll, no flicker); a filter/sort change replaces the whole grid
    function renderHits(hits) {
      if (!hitsEl || _degraded) return;
      var renderable = hits.filter(function (hit) { return getHandle(hit); });
      if (renderable.length) _renderedHits = true;
      // Diff key is the DOC id, not the handle: split docs share one handle, so a
      // handle-keyed diff reads any same-length reorder of a split product's cards
      // as "no change" and skips the re-render.
      var newHandles = renderable.map(function (hit) { return String(hit.id == null ? '' : hit.id); });

      var currentLis = Array.prototype.filter.call(hitsEl.children, function (el) {
        return el.nodeType === 1 && el.getAttribute('data-handle');
      });
      var currentHandles = currentLis.map(function (el) { return el.getAttribute('data-product-id') || ''; });

      // No change, skip to prevent redundant re-render flicker
      if (currentHandles.length === newHandles.length &&
        currentHandles.every(function (h, i) { return h === newHandles[i]; })) {
        return;
      }

      // Append-only when current cards are an exact prefix of the new results
      var isAppend = currentHandles.length > 0 && newHandles.length > currentHandles.length;
      if (isAppend) {
        for (var i = 0; i < currentHandles.length; i++) {
          if (currentHandles[i] !== newHandles[i]) { isAppend = false; break; }
        }
      }

      if (isAppend) {
        var addFrag = document.createDocumentFragment();
        for (var j = currentHandles.length; j < renderable.length; j++) {
          addFrag.appendChild(buildLi(renderable[j]));
        }
        hitsEl.appendChild(addFrag);
        return;
      }

      // First render over a visible server grid: keep the leading Liquid cards Meili confirms
      // (same id, same position), so nothing swaps; split docs ("v…" ids) never match
      if (!currentHandles.length && !document.documentElement.classList.contains('ms-grid-pending')) {
        var natives = Array.prototype.filter.call(hitsEl.children, function (el) {
          return el.nodeType === 1 && el.classList.contains('product-grid__item--native');
        });
        var kept = 0;
        while (kept < natives.length && kept < renderable.length &&
          natives[kept].getAttribute('data-product-id') === newHandles[kept]) {
          kept++;
        }
        if (kept) {
          for (var n = 0; n < kept; n++) {
            natives[n].setAttribute('data-handle', getHandle(renderable[n]));
            natives[n].classList.remove('ms-native--over-mobile', 'ms-native--over-desktop');
          }
          // Drop the unconfirmed Liquid cards and the skeletons, then build the rest
          Array.prototype.slice.call(hitsEl.children).forEach(function (el) {
            if (el.tagName === 'LI' && !el.getAttribute('data-handle')) el.remove();
          });
          var restFrag = document.createDocumentFragment();
          for (var r = kept; r < renderable.length; r++) restFrag.appendChild(buildLi(renderable[r]));
          hitsEl.appendChild(restFrag);
          _warmedAtCount = -1;
          return;
        }
      }

      // Full (re)render: initial load, filter or sort change. Reset the prefetch guard
      // so the next page of THIS result set gets warmed (the old count is meaningless
      // now that filters/sort changed).
      _warmedAtCount = -1;
      var frag = document.createDocumentFragment();
      renderable.forEach(function (hit) { frag.appendChild(buildLi(hit)); });
      hitsEl.replaceChildren(frag);
    }

    var _showMore = null;
    var _isLastPage = true;
    var _loading = false;
    var _warmedAtCount = -1;

    var connectInfinite = window.instantsearch.connectors.connectInfiniteHits(function (state) {
      _showMore = state.showMore;
      _isLastPage = state.isLastPage;
      _loading = false;
      if (loadMoreBtn) { loadMoreBtn.classList.remove('is-loading'); loadMoreBtn.removeAttribute('aria-busy'); }
      if (!hitsEl || _degraded) return;

      var hits = state.hits || [];
      if (hits.length) {
        renderHits(hits);
      } else if (state.results && state.results.nbHits === 0) {
        // A dead backend and a genuinely empty result set look identical here:
        // instant-meilisearch reports a missing index as zero hits rather than
        // throwing. With no filters applied, nothing ever rendered, and a server
        // grid that does have products, the collection cannot legitimately be
        // empty, so treat it as a backend failure instead of telling the shopper
        // there are no products.
        if (!_hasActiveRefinements && !_renderedHits && _fallbackHtml) {
          degradeToServerGrid('Meilisearch returned no hits for an unfiltered collection that Shopify rendered with products');
          return;
        }
        // 0 hits WITH active filters → hint + clear action; WITH NO filters → unchanged.
        hitsEl.innerHTML = _hasActiveRefinements
          ? '<li class="ms-pg-no-results ms-pg-no-results--filtered">' +
          '<p class="ms-pg-no-results__text">' + escapeHtml(config.noResultsFiltered || config.noResults || 'No products found.') + '</p>' +
          '<button type="button" class="cta cta--button-secondary cta--size-small" data-ms-clear-all>' +
          escapeHtml(config.clearAllText || 'Clear all') +
          '</button>' +
          '</li>'
          : '<li class="ms-pg-no-results">' + (config.noResults || 'No products found.') + '</li>';
      }

      if (sentinel) sentinel.hidden = _isLastPage;
      // Hide the whole row when there is no next page (incl. after a filter/sort
      // change that shrinks results to a single page) so nothing renders.
      if (loadMoreWrap) loadMoreWrap.hidden = _isLastPage;

      // Warm the next page once this one has settled (idle), so a later click/scroll
      // resolves from cache. Covers every user incl. touch (no hover needed).
      if (!_isLastPage) scheduleWarm();
    });
    // `cache` replays every "Load more" page after a Back navigation (see the
    // back-navigation block above). Feature-detected: an older instantsearch build
    // without it just keeps the previous page-0 behaviour rather than throwing.
    //
    // CONSENT-GATED: the cache lives in sessionStorage under `ais.infiniteHits`,
    // which Cookiebot's scanner counts as a cookie and classified as Preferences.
    // Attaching it before the visitor accepted Preferences made the CH scan of
    // 20.08.2026 fail "prior consent", so the cache is only wired when that
    // consent exists at page load; otherwise the widget runs uncached (Back
    // navigation lands on page 0, as before the cache was added). With no
    // consent manager on the page there is nothing to gate on. The key is wiped
    // on withdrawal by the cleanup listener in snippets/cookiebot.liquid.
    var infiniteOptions = { escapeHTML: false };
    var preferencesConsent = !window.Cookiebot ||
      !!(window.Cookiebot.consent && window.Cookiebot.consent.preferences);
    try {
      if (preferencesConsent &&
        typeof window.instantsearch.createInfiniteHitsSessionStorageCache === 'function') {
        infiniteOptions.cache = window.instantsearch.createInfiniteHitsSessionStorageCache();
      }
    } catch (e) { /* keep the uncached widget */ }
    widgets.push(connectInfinite(infiniteOptions));

    // Replay the last request batch with the hits page incremented, through the raw
    // (un-wrapped) search fn so the capture wrapper isn't re-entered. This populates
    // the adapter cache under the same key showMore() will request next.
    function warmNextPage() {
      if (_isLastPage || !_rawSearch || !_lastSearchRequests || !_lastSearchRequests.length) return;
      try {
        var clone = _lastSearchRequests.map(function (req) {
          var c = JSON.parse(JSON.stringify(req));
          // Bump page only on the hits request (facet-count requests use hitsPerPage:0
          // and keep page 0 across pages, matching what InstantSearch sends on showMore).
          if (c && c.params && typeof c.params.page === 'number' && c.params.hitsPerPage !== 0) {
            c.params.page = c.params.page + 1;
          }
          return c;
        });
        var p = _rawSearch(clone);
        if (p && typeof p.then === 'function') p.then(function () { }, function () { });
      } catch (e) { /* best-effort prefetch; ignore */ }
    }
    // Dedupe by shown-product count so hover + idle don't double-fire and each page is
    // warmed at most once. `immediate` (hover = strong click intent) skips the idle wait.
    function scheduleWarm(immediate) {
      if (_isLastPage || !hitsEl) return;
      var count = hitsEl.querySelectorAll('[data-handle]').length;
      if (!count || count === _warmedAtCount) return;
      _warmedAtCount = count;
      if (immediate === true) { warmNextPage(); return; }
      if ('requestIdleCallback' in window) window.requestIdleCallback(warmNextPage, { timeout: 1500 });
      else setTimeout(warmNextPage, 200);
    }

    function loadNext() {
      if (_loading || _isLastPage || !_showMore) return;
      _loading = true;
      // Busy state: dim + block re-clicks while the next page fetches.
      if (loadMoreBtn) { loadMoreBtn.classList.add('is-loading'); loadMoreBtn.setAttribute('aria-busy', 'true'); }
      _showMore();
    }
    // Hover = strong click intent: warm immediately (bypassing idle), still deduped.
    if (loadMoreBtn) loadMoreBtn.addEventListener('mouseenter', function () { scheduleWarm(true); });
    if (sentinel && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.isIntersecting) loadNext(); });
      }, { rootMargin: '600px 0px' }).observe(sentinel);
    }

    // Stats: product count in the toolbar + apply button
    var connectStats = window.instantsearch.connectors.connectStats(function (state, isFirst) {
      if (isFirst) return;
      var nb = state.nbHits || 0;
      document.querySelectorAll('.collection-toolbar__count').forEach(function (el) {
        el.textContent = productsCountLabel(nb);
      });
      document.querySelectorAll('[data-ms-count]').forEach(function (el) { el.textContent = nb; });
    });
    widgets.push(connectStats({}));

    // Network failures, auth errors and anything else instant-meilisearch throws
    // rather than swallowing. Without this the widgets simply stop updating and
    // whatever the last render left behind stays on screen.
    search.on('error', function (err) {
      var detail = (err && err.error && err.error.message) || (err && err.message) || 'unknown error';
      degradeToServerGrid('Meilisearch request failed (' + detail + ')');
    });

    search.addWidgets(widgets);
    search.start();

    // Delegated interactions: remove a single applied chip
    document.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-ms-chip]');
      if (!chip || !_refinementsState) return;
      var attr = chip.dataset.attr;
      var val = chip.dataset.val;
      _scrollPending = true;
      (_refinementsState.items || []).forEach(function (item) {
        if (item.attribute !== attr) return;
        // `val` is every raw value the chip stands for (unit-separator joined).
        var vals = String(val).split(SEP);
        item.refinements.forEach(function (r) {
          if (vals.indexOf(String(r.value)) !== -1) _refinementsState.refine(r);
        });
      });
    });

    // Remove the sort chip → back to the collection's admin order
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-ms-sort-chip]')) return;
      e.preventDefault();
      _scrollPending = true;
      if (_resetSort) _resetSort();
    });

    // Remove a category chip (drills the hero tabs back up a level)
    document.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-ms-cat-chip]');
      if (!chip) return;
      e.preventDefault();
      removeCategory(chip.getAttribute('data-ms-cat-chip'));
    });

    // Clear all filters (incl. the category path and the sort radios)
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-ms-clear-all]')) return;
      e.preventDefault();
      if (_resetSort) _resetSort();
      if (!_refinementsState) return;
      _scrollPending = true;
      (_refinementsState.items || []).forEach(function (item) {
        item.refinements.forEach(function (r) { _refinementsState.refine(r); });
      });
      _catPath = [];
      renderCategoryNav();
    });
  }

  // Decides whether the catch-all can behave like a hand-ordered collection.
  // The virtual /collections/all has no id, so the ordering collection
  // (ORDER_COLLECTION_HANDLE) is discovered IN THE INDEX: one search filtered by
  // its handle yields a member document, whose `collections` entry carries the
  // collection id. Two follow-up questions then gate the switch: does the index
  // hold memberships for that id (the `filter` request), and is its position
  // attribute registered as sortable (the `sort` request — an unregistered sort
  // field 400s the whole search, which is exactly why it can't just be assumed).
  // The sort probe only fires once memberships exist, so the everyday
  // not-synced-yet case stays a clean 200 instead of a console-logged 400. Only
  // every answer being yes calls back with the collection id — anything else
  // (no member found, 0 hits, a 400, a network failure) calls back with null and
  // the page keeps the plain virtual behavior: whole index, index order. It can
  // never go blank because the indexer hasn't caught up.
  function probeAllCollection(done) {
    function ask(body, cb) {
      fetch(String(HOST).replace(/\/+$/, '') + '/indexes/' + INDEX + '/search', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + API_KEY,
        },
        body: JSON.stringify(body),
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(cb)
        .catch(function () { cb(null); });
    }
    function verify(id) {
      ask({ q: '', limit: 0, filter: 'collections.id = ' + id }, function (data) {
        if (!data || !(data.estimatedTotalHits > 0)) return done(null);
        ask(
          { q: '', limit: 0, sort: ['position_in_collection_' + id + ':asc'] },
          function (sorted) { done(sorted ? id : null); }
        );
      });
    }
    // A real collection on the URL (only possible if the page ever stops being
    // virtual) wins over handle discovery.
    if (collectionId) return verify(collectionId);
    ask(
      { q: '', limit: 1, filter: 'collections.handle = "' + ORDER_COLLECTION_HANDLE + '"' },
      function (data) {
        var hit = data && data.hits && data.hits[0];
        var col = null;
        ((hit && hit.collections) || []).forEach(function (c) {
          if (c && c.handle === ORDER_COLLECTION_HANDLE) col = c;
        });
        if (!col || col.id == null) return done(null);
        verify(String(col.id));
      }
    );
  }

  function boot() {
    showSkeletons();
    if (IS_ALL_PRODUCTS) {
      probeAllCollection(function (orderId) {
        if (orderId) {
          // From here on the catch-all IS the ordering collection: the id
          // drives both the membership filter and the default sort field.
          collectionId = orderId;
          FILTER_BY_COLLECTION = true;
          HAS_COLLECTION_ORDER = true;
          computeSortDefaults();
        }
        initSearch();
      });
    } else {
      initSearch();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
